export default class FormFieldsControl {
    constructor(options) {
        /* Input Parameters */
        this.entityId = options.entityId;
        this.layoutId = options.layoutId;
        this.formId = options.formId;
        this.listId = options.listId;
        this.localization = options.localization;
        this.optionsContainer = options.optionsContainer;
        this.layoutFilter = options.layoutFilter;
        this.layoutTree = options.layoutTree;
        this.layoutDetail = options.layoutDetail;
        this.layoutTemplateWrapper = options.layoutTemplateWrapper;
        this.isFilter = options.isFilter;
        this.entityFields = [];

        /* Definition Layout Properties */
        this.fieldsContainer = options.fieldsContainer == null ? 'fields-choices-list' : options.fieldsContainer;
        this.fieldTitle = 'field-title';
        this.fieldName = 'field-name';
        this.fieldText = 'field-text';
        this.fieldLayoutCols = 'field-layout-cols';
        this.fieldClassName = 'field-class-name';
        this.fieldOperator = 'field-operator';
        this.fieldSqlWhereFilter = 'field-where-filter';
        this.fieldStyle = 'field-style';
        this.fieldHtmlAttributes = 'field-html-attributes';
        this.layoutTemplateInner = 'layout-template-inner';
        this.fieldCollapsable = 'field-collapsable';
        this.fieldCollapsed = 'field-collapsed';
        this.fieldLabel = 'field-label';
        this.fieldDataType = 'field-data-type';
        this.fieldCtlType = 'field-ctl-type';
        this.fieldPlatforms = 'field-platforms';
        this.fieldLoadCommand = 'field-load-command';
        this.fieldSaveCommand = 'field-save-command';
        this.fieldVisibilityCommand = 'field-visibility-command';
        this.fieldValidateCommand = 'field-validate-command';
        this.fieldReadonlyCommand = 'field-readonly-command';
        this.fieldCommandNotNull = 'field-notnull-command';
        this.fieldIdEntityMToN = 'field-id-entity-mton';
        this.fieldIdEntityFieldM = 'field-id-entity-entity-field-m';
        this.fieldIdEntityFieldN = 'field-id-entity-entity-field-n';
        this.fieldIdList = 'field-id-list';
        this.fieldAutobind = 'field-autobind'
        this.fieldReadonly = 'field-readonly';
        this.fieldRows = 'field-rows';
        this.fieldHidden = 'field-hidden';
        this.fieldMandatory = 'field-mandatory';
        this.fieldReadFromQr = 'field-read-from-qr';
        this.ctlTypeSpecifics = 'ctl-type-specifics';
        this.ctlCustomTypeSpecifics = 'ctl-custom-type-specifics';
        this.fieldDependsOn = 'field-depends-on';
        this.fieldCtlSubType = 'field-ctl-sub-type';
        this.fieldIdEntitySource = 'field-id-entity-source';
        this.fieldMapRef = 'field-map-ref';
        this.fieldWhereRootClause = 'field-where-root-clause';
        this.fieldSelectOnlyLeaves = 'field-select-only-leaves';
        this.fieldWhereClause = 'field-where-clause';
        this.fieldIdEntityFieldForm = 'field-id-entity-field-form';
        this.fieldIdEntityFieldSublist = 'field-id-entity-field-sublist';
        this.fieldOrderByClause = 'field-order-by-clause';
        this.fieldFormat = 'field-format';
        this.fieldDefValue = 'field-def-value';
        this.fieldDefValueEdit = 'field-def-value-edit';
        this.fieldDefValueType = 'field-def-value-type';
        this.fieldDefValueValue = 'field-def-value-value';
        this.fieldDefValueToken = 'field-def-value-token';
        this.fieldDefValueSql = 'field-def-value-sql';
        this.fieldApplyTo = 'field-apply-to';
        this.fieldsDatabaseItem = 'database-fields-item';
        this.fieldStyleWrapper = 'field-style-wrapper';
        this.fieldStyleInput = 'field-style-input';
        this.fieldStyleLabel = 'field-style-label';
        this.fieldStyleDescription = 'field-style-description';
        this.fieldStyleInner = 'field-style-inner';
        this.fieldStylePageButton = 'field-style-page-button';
        this.fieldStylePageLink = 'field-style-page-link';
        this.fieldStylePageWrapper = 'field-style-page-wrapper';
        this.fieldStyleCard = 'field-style-card';
        this.fieldStyleCardHeader = 'field-style-card-header';
        this.fieldStyleCardHeaderLabel = 'field-style-card-header-label';
        this.fieldStyleCardInner = 'field-style-card-inner';
        this.fieldDescription = 'field-description';
        this.fieldMinFitScale = 'min-fit-scale';

        /* Code Wrappers */
        this.styleWrapper = null;
        this.styleInput = null;
        this.styleLabel = null;
        this.styleDescription = null;
        this.styleInner = null;
        this.stylePageButton = null;
        this.stylePageLink = null;
        this.stylePageWrapper = null;
        this.styleCard = null;
        this.styleCardHeader = null;
        this.styleCardHeaderLabel = null;
        this.styleCardInner = null;

        /* Control Properties */
        this.selectedField = null;
        this.maxLayoutAttribute = 10;
        this.actionSubFormIdPkVal = 'IdUIObjTarget';
        this.actionSubFormIdForm = 'IdFormUIObjTarget';
        this.hasErrors = false;
        this._initControl();
    }

    /* Public Methods */

    getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    getEntityFields() {
        return this.entityFields;
    }

    getFields() {
        let item = $('#' + this.layoutTree).data("kendoTreeView").dataSource.data()[0];
        let result = [];

        this._getUiFields(item, result);

        return result;
    }

    saveLayout() {
        let layoutItem = $('#' + this.layoutTree).data("kendoTreeView").dataSource.data()[0];

        let data = JSON.stringify(layoutItem);

        let saveLayoutUrl = rootUrl + "UILayout/SaveUILayout";
        this.hasErrors = false;
        $.ajax({
            type: "POST",
            url: saveLayoutUrl,
            async: true,
            data: data,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result != null && (result.Error == null || result.Error == '')) {
                    let saveResponse = JSON.parse(result.jsonEntity);
                    this._handleEntityFormValidityMessage(saveResponse.InvalidProperties);
                    let jsonEntity = saveResponse.Layout;

                    this._generateUniqueIds(jsonEntity);
                    let dataSource = new kendo.data.HierarchicalDataSource({
                        data: [jsonEntity], schema: {
                            model: {
                                id: "Id",
                                children: "Items"
                            }
                        }
                    });

                    $('#' + this.layoutTree).data('kendoTreeView').setDataSource(dataSource);

                    $('#' + this.layoutTree).data('kendoTreeView').expand('.k-treeview-item');

                    if (!this.hasErrors) {
                        $('#tabFormFieldsSel').removeClass('form-fields-tab-error');
                    }

                    this._updateDroppable();

                    if (!this.isFilter) {
                        this._updatePreview();
                    }

                    $('#' + this.layoutDetail)[0].innerHTML = '';
                } else if (result == null || result.Error == null) {
                    toastr.error(this._getResource('GetLayoutError'));
                } else {
                    toastr.error(result.Error);
                }
            },
            error: (e) => {
                toastr.error(this._getResource('GetLayoutError'));
            }
        });
    }

    /* Private Methods */

    _initControl() {
        this._loadTree();
    }

    _loadTree() {
        let layoutTreeUrl = rootUrl + 'UILayout/GetUILayout?id=' + this.layoutId;

        $.ajax({
            type: "GET",
            url: layoutTreeUrl,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (this.entityId == null) {
                    this.entityId = result.Layout.IdEntity;
                }
                this._initOptions();
                this._handleEntityFormValidityMessage(result.InvalidProperties);
                this._initTree(result.Layout);
                notifyFilterLoaded();
                notifyFormLoaded();
            },
            error: (e) => {
                toastr.error(e.responseText, this._getResource('GetLayoutError'));
            }
        });
    }

    _handleEntityFormValidityMessage(invalidProperties) {
        if (invalidProperties != null && invalidProperties.length > 0) {
            let errorTemplate = '';
            invalidProperties.forEach(invalidProperty => {
                errorTemplate += '&#9632;' + (invalidProperty.PropertyName != null && invalidProperty.PropertyName != '' ? ('<strong>' + invalidProperty.PropertyName + ':</strong>' + ' ') : '') + ' ' + invalidProperty.Message + '<br>';

            });
            $('#entity-form-errors-container')[0].innerHTML = errorTemplate;
            $('#entity-form-validation-wrapper').show();
        } else {
            $('#entity-form-validation-wrapper').hide();
        }
    }

    _validateField(item) {
        if (item.InvalidProperties != null && item.InvalidProperties.length > 0) {
            item.InvalidProperties.forEach(property => {
                if ($('#' + property.PropertyName + '-validation').length == 0) {
                    alert(property.Message);
                }
                else {
                    $('#' + property.PropertyName + '-validation')[0].innerHTML = property.Message;
                }
            });
        }
    }

    _getUiFields(item, result) {
        if (item.TypeName == 'UIFieldControlDto') {
            result.push(item);
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._getUiFields(child, result);
            });
        }
    }

    _initTree(items) {
        this._generateUniqueIds(items);
        let dataSource = new kendo.data.HierarchicalDataSource({
            data: [items], schema: {
                model: {
                    id: "Id",
                    children: "Items"
                }
            }
        });

        if ($('#' + this.layoutTree).data('kendoTreeView') != null) {
            let parent = $('#' + this.layoutTree).parent();
            $('#' + this.layoutTree).data('kendoTreeView').destroy();
            $('#' + this.layoutTree).remove();
            parent.append('<div id="' + this.layoutTree + '" style="border:none !important; position: absolute; padding-top: 0; width: 100%;"></div>')
        }

        $('#' + this.layoutTree).kendoTreeView({
            template: (evt) => {
                let item = evt.item;
                let templ = '';

                if (item.InvalidProperties != null && item.InvalidProperties.length > 0) {
                    this.hasErrors = true;
                    let errorTitle = '';
                    $('#tabFormFieldsSel').addClass('form-fields-tab-error');
                    item.InvalidProperties.forEach(error => {
                        errorTitle += error.Message + '\n';
                    });
                    templ += '<div title="' + errorTitle + '" class="error-tree-node tree-item-description tree-' + item.TypeName + '">' + this._getTreeIconTemplate(item) + '<span class="tree-item-name">' + this._getTreeItemTemplate(item) + '<i class="ml-2 fal fa-exclamation-circle" style="font-weight: bold;"></i></span>' + this._getRemoveIconTemplate(item) + '</div>';
                } else {
                    templ += '<div class="tree-item-description tree-' + item.TypeName + '">' + this._getTreeIconTemplate(item) + '<span class="tree-item-name">' + this._getTreeItemTemplate(item) + '</span>' + this._getRemoveIconTemplate(item) + '</div>';
                }

                return templ;
            },
            dragAndDrop: true,
            dragend: (e) => {
                this._filterTree();
            },
            dragstart: (e) => {
                let sourceNodeType = $('#' + this.layoutTree).data('kendoTreeView').dataItem(e.sourceNode).TypeName;

                switch (sourceNodeType) {
                    case 'UILayoutDto': break;
                    case 'UITabControlDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UITabPageDto': {
                        $('.tree-UITabControlDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UIGroupDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UIParagraphDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UISublistDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UIMapViewDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UIFieldControlDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                    case 'UICustomFieldControlDto': {
                        $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                        $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                        $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                    };
                        break;
                }
            },
            loadOnDemand: false,
            dataSource: dataSource,
            dataTextField: "Name",
            dataValueField: "Id",
            select: (e) => {
                this._selectField(e);
            },
            drop: (e) => {
                try {
                    $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                    $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                    $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                    $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                    $('.tree-UITabControlDto').parent().removeClass('k-state-highlighted');
                    let isValid = false;

                    let sourceNodeType = $('#' + this.layoutTree).data('kendoTreeView').dataItem(e.sourceNode).TypeName;
                    let targetNodeType = $('#' + this.layoutTree).data('kendoTreeView').dataItem(e.destinationNode).TypeName;

                    if (e.dropPosition == 'over') {

                        switch (sourceNodeType) {
                            case 'UILayoutDto': isValid = false;
                                break;
                            case 'UITabControlDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UITabPageDto': isValid = targetNodeType == 'UITabControlDto';
                                break;
                            case 'UIGroupDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UIParagraphDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UISublistDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UIMapViewDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UIFieldControlDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                            case 'UICustomFieldControlDto': isValid = targetNodeType == 'UILayoutDto' || targetNodeType == 'UIGroupDto' || targetNodeType == 'UIParagraphDto' || targetNodeType == 'UITabPageDto';
                                break;
                        }
                    } else if (e.dropPosition != 'over' && sourceNodeType != 'UILayoutDto') {
                        if (sourceNodeType == 'UITabPageDto' && targetNodeType == 'UITabPageDto') {
                            isValid = true;
                        } else if (sourceNodeType != 'UITabPageDto' && targetNodeType != 'UITabPageDto') {
                            isValid = true;
                        }
                    }

                    if (isValid) {
                        setTimeout(() => {
                            this._updateDroppable();
                            this._updatePreview();
                        }, 50);
                    } else {
                        e.setValid(false);
                    }
                } catch (err) {
                    e.setValid(false);
                }
            }
        });
        $('#' + this.layoutTree).data('kendoTreeView').expand('.k-treeview-item');

        if (!this.hasErrors) {
            $('#tabFormFieldsSel').removeClass('form-fields-tab-error');
        }

        this._updateDroppable();
    }

    _selectField(item) {
        setTimeout(() => {
            this._selectNode(item.node);
        }, 50);
    }

    _selectNode(node) {
        let selectedItem = $('#' + this.layoutTree).data("kendoTreeView").dataItem(node);
        this.selectedField = selectedItem;

        switch (selectedItem.TypeName) {
            case 'UILayoutDto': this._selectLayoutNode(selectedItem);
                break;
            case 'UITabControlDto': this._selectTabControlNode(selectedItem);
                break;
            case 'UITabPageDto': this._selectTabPageNode(selectedItem);
                break;
            case 'UIGroupDto': this._selectGroupNode(selectedItem);
                break;
            case 'UIParagraphDto': this._selectParagraphNode(selectedItem);
                break;
            case 'UISublistDto': this._selectSublistNode(selectedItem);
                break;
            case 'UIMapViewDto': this._selectMapViewNode(selectedItem);
                break;
            case 'UIFieldControlDto': this._selectFieldControlNode(selectedItem);
                break;
            case 'UICustomFieldControlDto': this._selectCustomFieldControlNode(selectedItem);
                break;
            default: console.error(selectedItem.TypeName + ' control is not implemented...');
                break;
        }

        if (selectedItem.InvalidProperties != null && selectedItem.InvalidProperties.length > 0) {
            selectedItem.InvalidProperties.forEach((invalidProperty) => {
                if (invalidProperty.PropertyName == 'Name' || invalidProperty.PropertyName == 'ClassName' || invalidProperty.PropertyName == 'DefValue' || invalidProperty.PropertyName == 'DefValue' || invalidProperty.PropertyName == 'Style' || invalidProperty.PropertyName == 'HtmlAttributes') {
                    $('#ui-item-advanced-details-anchor').addClass('form-fields-tab-error');
                    $('#ui-item-general-details-anchor').removeClass('form-fields-tab-error');
                } else {
                    $('#ui-item-general-details-anchor').addClass('form-fields-tab-error');
                    $('#ui-item-advanced-details-anchor').removeClass('form-fields-tab-error');
                }
            });
        }

        this._validateField(this.selectedField);
    }

    _selectLayoutNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getLayoutNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldClassName).val(node.ClassName);
        $('#' + this.fieldDescription).val(node.Description);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.isFilter) {
            $("#" + this.fieldCollapsed).kendoSwitch({
                messages: {
                    checked: this._getResource('SWITCH_ON'),
                    unchecked: this._getResource('SWITCH_OFF')
                },
                checked: this.selectedField.Collapsed,
                change: (e) => {
                    this.selectedField.Collapsed = e.checked;

                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        this._addLayoutTemplateEvents();
    }

    _selectTabControlNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getTabControlNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });        
        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }
                
        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
    }

    _selectTabPageNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getTabPageNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldText).val(node.Text);
        $('#' + this.fieldClassName).val(node.ClassName);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldText).on('focusout', () => {
            let fieldTextValue = $('#' + this.fieldText).val();
            this.selectedField.Text = fieldTextValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }
                
        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
    }

    _selectGroupNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getGroupNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldText).val(node.Text);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldText).on('focusout', () => {
            let fieldTextValue = $('#' + this.fieldText).val();
            this.selectedField.Text = fieldTextValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $("#" + this.fieldCollapsable).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.Collapsable,
            change: (e) => {
                this.selectedField.Collapsable = e.checked;
                if (!e.checked) {
                    $("#" + this.fieldCollapsed).data('kendoSwitch').check(false);
                    this.selectedField.Collapsed = false;
                }

                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldCollapsed).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.Collapsed,
            change: (e) => {
                if (!e.checked && !($("#" + this.fieldCollapsable).data('kendoSwitch').check())) {
                    e.preventDefault();
                } else {
                    this.selectedField.Collapsed = e.checked;
                }

                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }
                
        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
    }

    _selectMapViewNode(node) {
        if (node.Style == null) {
            node.Style = '{"styleWrapper":"","styleLabel":"","styleDescription":"","styleInner":"height: 30Rem;"}';
        }

        $('#' + this.layoutDetail)[0].innerHTML = this._getMapViewNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);
        $('#' + this.fieldLabel).val(node.Label);
        $('#' + this.fieldDescription).val(node.Description);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLabel).on('focusout', () => {
            let fieldLabelValue = $('#' + this.fieldLabel).val();
            this.selectedField.Label = fieldLabelValue;
            this._updateDroppable();
            this._updatePreview();
        });


        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldMapRef).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldMapRef).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Map/GetMaps';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();

                if (value != null && value != '') {
                    $('#' + this.fieldMapRef + '-navigator').show();
                } else {
                    $('#' + this.fieldMapRef + '-navigator').hide();
                }

                this.selectedField.IdMap = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdMap != null) {
            $('#' + this.fieldMapRef + '-navigator').show();
            $('#' + this.fieldMapRef).data('kendoComboBox').value(this.selectedField.IdMap);
        } else {
            $('#' + this.fieldMapRef + '-navigator').hide();
        }

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }
                
        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
        addHelp();
    }

    _selectSublistNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getSublistNodeTemplate();

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);
        $('#' + this.fieldLabel).val(node.Label);
        $('#' + this.fieldDescription).val(node.Description);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLabel).on('focusout', () => {
            let fieldLabelValue = $('#' + this.fieldLabel).val();
            this.selectedField.Label = fieldLabelValue;
            this._updateDroppable();
            this._updatePreview();
        });


        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.selectedField.SqlWhere != null && this.selectedField.SqlWhere.length > 0) {
            $('#' + this.fieldWhereClause).val(this.selectedField.SqlWhere);
        }

        $('#' + this.fieldWhereClause).on('focusout', () => {
            let fieldWhereClauseValue = $('#' + this.fieldWhereClause).val();
            this.selectedField.SqlWhere = fieldWhereClauseValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldIdEntityFieldForm).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntityFieldForm).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getEntityFields(),
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.IdEntityFieldForm = this.getNumber(value);
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntityFieldForm != null && this.selectedField.IdEntityFieldForm > 0) {
            $('#' + this.fieldIdEntityFieldForm).data('kendoComboBox').value(this.selectedField.IdEntityFieldForm);
        }

        $('#' + this.fieldIdList).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdList).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityList/GetList';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();

                if (value != null && value != '') {
                    $('#' + this.fieldIdList + '-navigator').show();
                } else {
                    $('#' + this.fieldIdList + '-navigator').hide();
                }

                this.selectedField.IdList = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdList != null) {
            $('#' + this.fieldIdList + '-navigator').show();
            $('#' + this.fieldIdList).data('kendoComboBox').value(this.selectedField.IdList);
        } else {
            $('#' + this.fieldIdList + '-navigator').hide();
        }

        $('#' + this.fieldIdEntityFieldSublist).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntityFieldSublist).parent()
            },
            cascadeFrom: this.fieldIdList,
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityList/GetEntityFields?idList=' + $('#' + this.fieldIdList).data('kendoComboBox').value();
                        }
                    }
                }
            },
            change: (e) => {
                //cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.IdEntityFieldSublist = this.getNumber(value);
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntityFieldSublist != null && this.selectedField.IdEntityFieldSublist > 0) {
            $('#' + this.fieldIdEntityFieldSublist).data('kendoComboBox').value(this.selectedField.IdEntityFieldSublist);
        }

        if (this.selectedField.CtlProps == null || this.selectedField.CtlProps.Autobind == null) {
            this.selectedField.CtlProps = {
                Autobind: true
            };
        }

        $("#" + this.fieldAutobind).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.CtlProps.Autobind,
            change: (e) => {
                let value = e.checked;
                this.selectedField.CtlProps.Autobind = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }

        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
        addHelp();
    }

    _getEntityFields() {
        let result = [];

        this.entityFields.forEach(entityField => {
            result.push({ Id: entityField.Id, Name: entityField.FieldName });
        });

        return result;
    }

    _selectParagraphNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getParagraphNodeTemplate();

        $('#' + this.fieldLabel).val(node.Label);
        $('#' + this.fieldDescription).val(node.Description);
        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this.selectedField.set('displayText', this.selectedField.Name);
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLabel).on('focusout', () => {
            let fieldLabelValue = $('#' + this.fieldLabel).val();
            this.selectedField.Label = fieldLabelValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }

        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        this._addLayoutTemplateEvents();
    }

    getNumber(source) {
        if (source == null || source == '') {
            return null;
        }
        else {
            return new Number(source);
        }
    }

    _selectCustomFieldControlNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getCustomFieldNodeTemplate();

        if (this.selectedField.CtlProps == null) {
            this.selectedField.CtlProps = {};
        }

        if (node.DefValue != null && node.DefValue.ValueType != null) {
            if (node.DefValue.ValueType == 'VALUE' && node.DefValue.Value != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Value);
            } else if (node.DefValue.ValueType == 'TOKEN' && node.DefValue.Token != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Token);
            } else if (node.DefValue.ValueType == 'SQL' && node.DefValue.Sql != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Sql);
            }
        }

        $('#' + this.fieldDefValueEdit).on('click', () => {
            this._handleDefValueEdit();
        });

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);
        $('#' + this.fieldLabel).val(node.Label);
        $('#' + this.fieldDescription).val(node.Description);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this._filterTree();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLabel).on('focusout', () => {
            let fieldLabelValue = $('#' + this.fieldLabel).val();
            this.selectedField.Label = fieldLabelValue;
            this._updateDroppable();
            this._updatePreview();
        });


        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLoadCommand).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldLoadCommand).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.IdXpCommandLoad = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdXpCommandLoad != null) {
            $('#' + this.fieldLoadCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandLoad);
        }

        $('#' + this.fieldSaveCommand).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldSaveCommand).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.IdXpCommandSave = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdXpCommandSave != null) {
            $('#' + this.fieldSaveCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandSave);
        }

        $('#' + this.fieldDataType).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldDataType).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFieldDataType';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.DataType = value;
                this._updateDroppable();
                this._updatePreview();

                $('#' + this.fieldCtlType).data('kendoComboBox').value(null);
                $('#' + this.fieldCtlType).data('kendoComboBox').dataSource.read();

                this.selectedField.CtlType = null;
                this._hideMultiSelectOptions();
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (e.sender.value() == null || e.sender.value() == '') {
                    if (currentData != null && currentData.length > 0) {
                        let value = currentData[0].Id;
                        e.sender.value(value);
                        this.selectedField.DataType = value;
                        this._updateDroppable();
                        this._updatePreview();
                    }
                }
            }
        });

        if (this.selectedField.DataType != null) {
            $('#' + this.fieldDataType).data('kendoComboBox').value(this.selectedField.DataType);
        }

        $('#' + this.fieldCtlType).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldCtlType).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            let dataType = 'STRING';

                            if (this.selectedField.EntityField) {
                                dataType = this.selectedField.EntityField.DataType;
                            } else if ($('#' + this.fieldDataType).data('kendoComboBox') != null) {
                                let cboxDataType = $('#' + this.fieldDataType).data('kendoComboBox').value();

                                if (cboxDataType != null && cboxDataType != '') {
                                    dataType = cboxDataType;
                                }
                            }
                            return rootURL + 'UILayout/GetCtlType?dataType=' + dataType;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.CtlType = value;
                this._updateDroppable();
                this._updatePreview();
                this._hideMultiSelectOptions();

                switch (value) {
                    case 'ComboBox': this._handleComboBoxSpecifics(true);
                        break;
                    case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                        break;
                    case 'IntegerTextBox':
                    case 'DatePicker':
                    case 'DateTimePicker':
                    case 'NumericTextBox': this._handleInputSpecifics();
                        break;
                    default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
                }
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (e.sender.value() == null || e.sender.value() == '') {
                    if (currentData != null && currentData.length > 0) {
                        let value = currentData[0].Id;
                        e.sender.value(value);
                        this.selectedField.CtlType = value;
                        this._updateDroppable();
                        this._updatePreview();

                        switch (value) {
                            case 'ComboBox': this._handleComboBoxSpecifics(true);
                                break;
                            case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                                break;
                            case 'IntegerTextBox':
                            case 'DatePicker':
                            case 'DateTimePicker':
                            case 'NumericTextBox': this._handleInputSpecifics();
                                break;
                            default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
                        }
                    }
                }
            }
        });

        if (this.selectedField.CtlType != null) {
            $('#' + this.fieldCtlType).data('kendoComboBox').value(this.selectedField.CtlType);

            switch (this.selectedField.CtlType) {
                case 'ComboBox': this._handleComboBoxSpecifics(true);
                    break;
                case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                    break;
                case 'IntegerTextBox':
                case 'DatePicker':
                case 'DateTimePicker':
                case 'NumericTextBox': this._handleInputSpecifics();
                    break;
                default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
            }
        }

        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        $('#' + this.fieldPlatforms).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldPlatforms).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UILayout/GetPlatforms';
                        }
                    }
                }
            },
            change: (e) => {
                this._platform_onChange(e);
                let platforms = this._getPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'));
                this.selectedField.Platforms = platforms;
                this._updatePreview();
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if ($('#' + this.fieldPlatforms).data('kendoMultiSelect') != null) {
            this._setPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'), this.selectedField.Platforms);
        }

        $("#" + this.fieldReadonly).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.IsReadOnly != null && this.selectedField.IsReadOnly == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.IsReadOnly = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldHidden).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.Hidden != null && this.selectedField.Hidden == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.Hidden = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldMandatory).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.NotNull != null && this.selectedField.NotNull == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.NotNull = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldReadFromQr).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.CtlProps.ReadFromQr != null && this.selectedField.CtlProps.ReadFromQr == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.CtlProps.ReadFromQr = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $('#' + this.fieldOperator).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldOperator).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            let dataType = 'STRING';

                            if (this.selectedField.EntityField) {
                                dataType = this.selectedField.EntityField.DataType;
                            } else if ($('#' + this.fieldDataType).data('kendoComboBox') != null) {
                                let cboxDataType = $('#' + this.fieldDataType).data('kendoComboBox').value();

                                if (cboxDataType != null && cboxDataType != '') {
                                    dataType = cboxDataType;
                                }
                            }
                            return rootURL + 'Entity/GetFieldFilterOp?dataType=' + dataType;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.FilterOp = value;
                if (value == 'SQL') {
                    $('#div_' + this.fieldSqlWhereFilter).show();
                }
                else {
                    $('#div_' + this.fieldSqlWhereFilter).hide();
                }
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.FilterOp != null) {
            $('#' + this.fieldOperator).data('kendoComboBox').value(this.selectedField.FilterOp);
            if (this.selectedField.FilterOp == 'SQL') {
                $('#div_' + this.fieldSqlWhereFilter).show();
            }
            else {
                $('#div_' + this.fieldSqlWhereFilter).hide();
            }
        }
        if (this.selectedField.SqlWhereFilter != null) {
            $('#' + this.fieldSqlWhereFilter).val(this.selectedField.SqlWhereFilter);
        }
        $('#' + this.fieldSqlWhereFilter).on('focusout', () => {
            debugger;
            let fieldSqlWhereFilter = $('#' + this.fieldSqlWhereFilter).val();
            this.selectedField.SqlWhereFilter = fieldSqlWhereFilter;
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }

        if (this.formId != null) {
            $('#' + this.fieldCommandNotNull).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldCommandNotNull).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandNotNull = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldCommandNotNull).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldCommandNotNull).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandNotNull = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandNotNull != null) {
            $('#' + this.fieldCommandNotNull).data('kendoComboBox').value(this.selectedField.IdXpCommandNotNull);
        }

        this._addLayoutTemplateEvents();
        addHelp();
    }

    _selectFieldControlNode(node) {
        $('#' + this.layoutDetail)[0].innerHTML = this._getFieldNodeTemplate();

        if (this.selectedField.CtlProps == null) {
            this.selectedField.CtlProps = {};
        }

        if (node.DefValue != null && node.DefValue.ValueType != null) {
            if (node.DefValue.ValueType == 'VALUE' && node.DefValue.Value != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Value);
            } else if (node.DefValue.ValueType == 'TOKEN' && node.DefValue.Token != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Token);
            } else if (node.DefValue.ValueType == 'SQL' && node.DefValue.Sql != null) {
                $('#' + this.fieldDefValue).val(node.DefValue.Sql);
            }
        }

        $('#' + this.fieldDefValueEdit).on('click', () => {
            this._handleDefValueEdit();
        });

        $('#' + this.fieldTitle)[0].innerHTML = this._getResource(node.TypeName);
        $('#' + this.fieldName).val(node.Name);
        $('#' + this.fieldLayoutCols).val(node.LayoutCols);
        $('#' + this.fieldClassName).val(node.ClassName);
        $('#' + this.fieldLabel).val(node.Label);
        $('#' + this.fieldDescription).val(node.Description);

        $('#' + this.fieldName).on('focusout', () => {
            let fieldNameValue = $('#' + this.fieldName).val();
            this.selectedField.Name = fieldNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLayoutCols).on('focusout', () => {
            let fieldLayoutColsValue = $('#' + this.fieldLayoutCols).val();
            this.selectedField.LayoutCols = fieldLayoutColsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldClassName).on('focusout', () => {
            let fieldClassNameValue = $('#' + this.fieldClassName).val();
            this.selectedField.ClassName = fieldClassNameValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldLabel).on('focusout', () => {
            let fieldLabelValue = $('#' + this.fieldLabel).val();
            this.selectedField.Label = fieldLabelValue;
            this._updateDroppable();
            this._updatePreview();
        });


        $('#' + this.fieldDescription).on('focusout', () => {
            let fieldDescriptionValue = $('#' + this.fieldDescription).val();
            this.selectedField.Description = fieldDescriptionValue;
            this._updateDroppable();
            this._updatePreview();
        });

        $('#' + this.fieldCtlType).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldCtlType).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UILayout/GetCtlType?dataType=' + this.selectedField.EntityField.DataType + '&dataSubtype=' + this.selectedField.EntityField.DataSubType;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.CtlType = value;
                this._updateDroppable();
                this._updatePreview();

                switch (value) {
                    case 'ComboBox': this._handleComboBoxSpecifics();
                        break;
                    case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                        break;
                    case 'IntegerTextBox':
                    case 'DatePicker':
                    case 'DateTimePicker':
                    case 'NumericTextBox': this._handleInputSpecifics();
                        break;
                    default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
                }
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (e.sender.value() == null || e.sender.value() == '') {
                    if (currentData != null && currentData.length > 0) {
                        let value = currentData[0].Id;
                        e.sender.value(value);
                        this.selectedField.CtlType = value;
                        this._updateDroppable();
                        this._updatePreview();

                        switch (value) {
                            case 'ComboBox': this._handleComboBoxSpecifics();
                                break;
                            case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                                break;
                            case 'IntegerTextBox':
                            case 'DatePicker':
                            case 'DateTimePicker':
                            case 'NumericTextBox': this._handleInputSpecifics();
                                break;
                            default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
                        }
                    }
                }
            }
        });

        if (this.selectedField.CtlType != null) {
            $('#' + this.fieldCtlType).data('kendoComboBox').value(this.selectedField.CtlType);

            switch (this.selectedField.CtlType) {
                case 'ComboBox': this._handleComboBoxSpecifics();
                    break;
                case 'GeomPicker': this._handleGeometryPickerSpecificsSpecifics();
                    break;
                case 'IntegerTextBox':
                case 'DatePicker':
                case 'DateTimePicker':
                case 'NumericTextBox': this._handleInputSpecifics();
                    break;
                default: $('#' + this.ctlTypeSpecifics)[0].innerHTML = '';
            }
        }

        $('#' + this.fieldDependsOn).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldDependsOn).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getConfiguredControlTriggers(),
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.DependsOnGuids = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.DependsOnGuids != null && this.selectedField.DependsOnGuids.length > 0) {
            $('#' + this.fieldDependsOn).data('kendoMultiSelect').value(this.selectedField.DependsOnGuids);
        }

        $('#' + this.fieldPlatforms).kendoMultiSelect({
            popup: {
                appendTo: $('#' + this.fieldPlatforms).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UILayout/GetPlatforms';
                        }
                    }
                }
            },
            change: (e) => {
                this._platform_onChange(e);
                let platforms = this._getPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'));
                this.selectedField.Platforms = platforms;
                this._updatePreview();
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if ($('#' + this.fieldPlatforms).data('kendoMultiSelect') != null) {
            this._setPlatform($('#' + this.fieldPlatforms).data('kendoMultiSelect'), this.selectedField.Platforms);
        }

        $("#" + this.fieldReadonly).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.IsReadOnly != null && this.selectedField.IsReadOnly == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.IsReadOnly = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldHidden).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.Hidden != null && this.selectedField.Hidden == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.Hidden = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldMandatory).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.NotNull != null && this.selectedField.NotNull == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.NotNull = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $("#" + this.fieldReadFromQr).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: this.selectedField.CtlProps.ReadFromQr != null && this.selectedField.CtlProps.ReadFromQr == true,
            change: (e) => {
                let value = e.checked;
                this.selectedField.CtlProps.ReadFromQr = value;
                this._updateDroppable();
                this._updatePreview();
            }
        });

        $('#' + this.fieldOperator).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldOperator).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFieldFilterOp?dataType=' + this.selectedField.EntityField.DataType + '&dataSubType=' + this.selectedField.EntityField.DataSubType;
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.FilterOp = value;
                if (value == 'SQL') {
                    $('#div_' + this.fieldSqlWhereFilter).show();
                }
                else {
                    $('#div_' + this.fieldSqlWhereFilter).hide();
                }
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.FilterOp != null) {
            $('#' + this.fieldOperator).data('kendoComboBox').value(this.selectedField.FilterOp);
            if (this.selectedField.FilterOp == 'SQL') {
                $('#div_' + this.fieldSqlWhereFilter).show();
            }
            else {
                $('#div_' + this.fieldSqlWhereFilter).hide();
            }
        }
        if (this.selectedField.SqlWhereFilter != null) {
            $('#' + this.fieldSqlWhereFilter).val(this.selectedField.SqlWhereFilter);
        }
        $('#' + this.fieldSqlWhereFilter).on('focusout', () => {
            debugger;
            let fieldSqlWhereFilter = $('#' + this.fieldSqlWhereFilter).val();
            this.selectedField.SqlWhereFilter = fieldSqlWhereFilter;
        });

        if (this.formId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldVisibilityCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldVisibilityCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandVisible = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandVisible != null) {
            $('#' + this.fieldVisibilityCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandVisible);
        }

        if (this.formId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldValidateCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldValidateCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandValid = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandValid != null) {
            $('#' + this.fieldValidateCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandValid);
        }

        if (this.formId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldReadonlyCommand).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldReadonlyCommand).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandReadOnly = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandReadOnly != null) {
            $('#' + this.fieldReadonlyCommand).data('kendoComboBox').value(this.selectedField.IdXpCommandReadOnly);
        }

        if (this.formId != null) {
            $('#' + this.fieldCommandNotNull).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldCommandNotNull).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityForm/GetXpCommands?idForm=' + this.formId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandNotNull = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.listId != null) {
            $('#' + this.fieldCommandNotNull).kendoComboBox({
                popup: {
                    appendTo: $('#' + this.fieldCommandNotNull).parent()
                },
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return rootURL + 'EntityList/GetXpCommands?idList=' + this.listId;
                            }
                        }
                    }
                },
                change: (e) => {
                    cb_onChange(e);
                    let value = e.sender.value();
                    this.selectedField.IdXpCommandNotNull = value;
                    this._updateDroppable();
                    this._updatePreview();
                }
            });
        }
        if (this.selectedField.IdXpCommandNotNull != null) {
            $('#' + this.fieldCommandNotNull).data('kendoComboBox').value(this.selectedField.IdXpCommandNotNull);
        }

        this._addLayoutTemplateEvents();
        addHelp();
    }

    _handleDefValueEdit() {
        if (this.selectedField.DefValue == null) {
            this.selectedField.DefValue = {
                Value: null,
                ValueType: (this.selectedField.EntityField == null || (this.selectedField.EntityField.DataType != 'GEOMETRY' && this.selectedField.EntityField.DataType != 'BYTEA') ? 'VALUE' : 'SQL'),
                ApplyTo: 'NEW'
            };
        }

        $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr-0" id="` + this.fieldsDatabaseItem + `"></div>`;

        let windowOptions = {
            draggable: false,
            resizable: true,
            width: "40rem",
            height: "auto",
            title: this._getResource('EditValue'),
            modal: true,
            close: () => { this._closeDefValueWindow(); }
        };

        $('#' + this.fieldsDatabaseItem).kendoWindow(windowOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }

        this._initDefValueWindow();
        $('#' + this.fieldsDatabaseItem).data("kendoWindow").center();
    }

    _closeDefValueWindow() {
        $('#' + this.fieldsDatabaseItem).data("kendoWindow").destroy();
    }

    _initDefValueValue() {
        let dataType = 'STRING';

        if (this.selectedField.EntityField) {
            dataType = this.selectedField.EntityField.DataType;
        } else if ($('#' + this.fieldDataType).data('kendoComboBox') != null) {
            let cboxDataType = $('#' + this.fieldDataType).data('kendoComboBox').value();

            if (cboxDataType != null && cboxDataType != '') {
                dataType = cboxDataType;
            }
        }

        switch (dataType) {
            case 'DATE': {
                $("#" + this.fieldDefValueValue).kendoDatePicker();
                if (this.selectedField.DefValue.Value != null) {
                    $("#" + this.fieldDefValueValue).data("kendoDatePicker").value(stringToDate1(this.selectedField.DefValue.Value));
                }
            }
                break;
            case 'TIMESTAMP': {
                $("#" + this.fieldDefValueValue).kendoDateTimePicker();
                $("#" + this.fieldDefValueValue).data("kendoDateTimePicker").value(stringToDate1(this.selectedField.DefValue.Value));
            }
                break;
            case 'BOOLEAN': {
                $("#" + this.fieldDefValueValue).kendoSwitch({
                    messages: {
                        checked: this._getResource('SWITCH_ON'),
                        unchecked: this._getResource('SWITCH_OFF')
                    },
                    checked: this.selectedField.DefValue.Value != null && this.selectedField.DefValue.Value == 'true'
                });
            }
                break;
            case 'BOOLINT': {
                $("#" + this.fieldDefValueValue).kendoSwitch({
                    messages: {
                        checked: this._getResource('SWITCH_ON'),
                        unchecked: this._getResource('SWITCH_OFF')
                    },
                    checked: this.selectedField.DefValue.Value != null && this.selectedField.DefValue.Value == '1'
                });
            }
                break;
            default: {
                if (this.selectedField.DefValue.Value != null) {
                    $("#" + this.fieldDefValueValue).val(this.selectedField.DefValue.Value);
                }
            }
                break;
        }
    }

    _saveDefValue() {
        this.selectedField.DefValue.ApplyTo = $('#' + this.fieldApplyTo).data('kendoComboBox').value();

        let defValueType = 'VALUE';

        let valueTypeInputs = $('#' + this.fieldDefValueType + ' input');

        for (var i = 0; i < valueTypeInputs.length; i++) {
            if (valueTypeInputs[i].checked) {
                defValueType = $(valueTypeInputs[i]).attr('data-option');
            }
        }

        this.selectedField.DefValue.ValueType = defValueType;

        if (defValueType == 'SQL') {
            this.selectedField.DefValue.Sql = $('#' + this.fieldDefValueSql).val();
        } else if (defValueType == 'TOKEN') {
            this.selectedField.DefValue.Token = $('#' + this.fieldDefValueToken).data('kendoComboBox').value();
        } else {
            switch (this.selectedField.EntityField.DataType) {
                case 'STRING': this.selectedField.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'NUMERIC': this.selectedField.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'INTEGER': this.selectedField.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'DATE': this.selectedField.DefValue.Value = dateToString1($('#' + this.fieldDefValueValue).data("kendoDatePicker").value());
                    break;
                case 'TIMESTAMP': this.selectedField.DefValue.Value = dateToString1($('#' + this.fieldDefValueValue).data("kendoDateTimePicker").value());
                    break;
                case 'BOOLEAN': this.selectedField.DefValue.Value = $('#' + this.fieldDefValueValue).data('kendoSwitch').check() ? 'true' : 'false';
                    break;
                case 'BOOLINT': this.selectedField.DefValue.Value = $('#' + this.fieldDefValueValue).data('kendoSwitch').check() ? '1' : '0';
                    break;
                default:
                    break;
            }
        }

        if (this.selectedField.DefValue != null && this.selectedField.DefValue.ValueType != null) {
            if (this.selectedField.DefValue.ValueType == 'VALUE' && this.selectedField.DefValue.Value != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.DefValue.Value);
            } else if (this.selectedField.DefValue.ValueType == 'TOKEN' && this.selectedField.DefValue.Token != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.DefValue.Token);
            } else if (this.selectedField.DefValue.ValueType == 'SQL' && this.selectedField.DefValue.Sql != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.DefValue.Sql);
            }
        }

        if (this.selectedField.DefValue != null && (this.selectedField.DefValue.Value == null || this.selectedField.DefValue.Value == '') && this.selectedField.DefValue.Token == null && this.selectedField.DefValue.Sql == null) {
            this.selectedField.DefValue = null;
        }

        this._closeDefValueWindow();
    }

    _handleInputSpecifics() {
        let inputSpecificsTemplate = this._getInputSpecificsTemplate();

        $('#' + this.ctlTypeSpecifics)[0].innerHTML = inputSpecificsTemplate;

        if (this.selectedField.Format != null && this.selectedField.Format.length > 0) {
            $('#' + this.fieldFormat).val(this.selectedField.Format);
        }

        $('#' + this.fieldFormat).on('focusout', () => {
            let fieldFormatValue = $('#' + this.fieldFormat).val();
            this.selectedField.Format = fieldFormatValue;
            this._updateDroppable();
            this._updatePreview();
        });
    }

    _handleGeometryPickerSpecificsSpecifics() {
        let geometryPickerSpecificsTemplate = this._getGeometryPickerSpecificsTemplate();

        $('#' + this.ctlTypeSpecifics)[0].innerHTML = geometryPickerSpecificsTemplate;

        $('#' + this.fieldCtlSubType).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldCtlSubType).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UILayout/GetCtlSubType?ctlType=GeomPicker';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.CtlProps.CtlSubType = value;

                if (value == 'MapView') {
                    if (this.selectedField.Style == null || this.selectedField.Style.trim() == '') {
                        this.selectedField.Style = '{"styleWrapper":"","styleInput":"height: 30rem;","styleLabel":"","styleDescription":""}';
                    }
                } else {
                    if (this.selectedField.Style != null && this.selectedField.Style.trim() == '{"styleWrapper":"","styleInput":"height: 30rem;","styleLabel":"","styleDescription":""}') {
                        this.selectedField.Style = null;
                    }
                }

                this._updateDroppable();
                this._updatePreview();
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (this.selectedField.CtlProps == null || this.selectedField.CtlProps.CtlSubType == null || this.selectedField.CtlProps.CtlSubType.trim() == '') {
                    e.sender.value(currentData[0].Id);
                    this.selectedField.CtlProps.CtlSubType = currentData[0].Id;
                    if (currentData[0].Id == 'MapView') {
                        this.selectedField.Style = '{"styleWrapper":"","styleInput":"height: 30rem;","styleLabel":"","styleDescription":""}';
                    }
                }
            }
        });

        if (this.selectedField.CtlProps != null && this.selectedField.CtlProps.CtlSubType != null && this.selectedField.CtlProps.CtlSubType.length > 0) {
            $('#' + this.fieldCtlSubType).data('kendoComboBox').value(this.selectedField.CtlProps.CtlSubType);
        }

        $('#' + this.fieldMapRef).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldMapRef).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Map/GetMaps';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.IdMap = value;
                this._updateDroppable();
                this._updatePreview();
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (this.selectedField.IdMap == null) {
                    e.sender.value(currentData[0].Id);
                    this.selectedField.IdMap = currentData[0].Id;
                }
            }
        });

        if (this.selectedField.IdMap != null) {
            $('#' + this.fieldMapRef).data('kendoComboBox').value(this.selectedField.IdMap);
        }

        $('#' + this.fieldMinFitScale).on('focusout', () => {
            let fieldMinFitScaleValue = $('#' + this.fieldMinFitScale).val();
            this.selectedField.CtlProps.MinFitScale = fieldMinFitScaleValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.selectedField.CtlProps != null) {
            $('#' + this.fieldMinFitScale).val(this.selectedField.CtlProps.MinFitScale);
        }
    }

    _handleComboBoxSpecifics(isCustom) {
        let comboBoxSpecificsTemplate = this._getComboBoxSpecificsTemplate();

        $('#' + this.ctlTypeSpecifics)[0].innerHTML = comboBoxSpecificsTemplate;

        $('#' + this.fieldIdEntitySource).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntitySource).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetEntity?filter=' + $('#' + this.fieldIdEntitySource).data('kendoComboBox').text();
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.IdEntitySource = this.getNumber(value);
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntitySource != null) {
            $('#' + this.fieldIdEntitySource).data('kendoComboBox').value(this.selectedField.IdEntitySource);
        }

        $('#' + this.fieldCtlSubType).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldCtlSubType).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UILayout/GetCtlSubType?ctlType=ComboBox';
                        }
                    }
                }
            },
            change: (e) => {
                cb_onChange(e);
                let value = e.sender.value();
                this.selectedField.CtlProps.CtlSubType = value;
                if (this.selectedField.CtlProps.CtlSubType == "TreeView") {
                    $('#div_' + this.fieldWhereRootClause).show();
                    $('#div_' + this.fieldSelectOnlyLeaves).show();
                }
                else {
                    $('#div_' + this.fieldWhereRootClause).hide();
                    $('#div_' + this.fieldSelectOnlyLeaves).hide();
                }

                if (isCustom) {
                    if (this.selectedField.CtlProps.CtlSubType == "MultiSelect") {
                        this._showMultiSelectOptions();
                    } else {
                        this._hideMultiSelectOptions();
                    }
                }

                this._updateDroppable();
                this._updatePreview();
            },
            dataBound: (e) => {
                let currentData = e.sender.dataSource.data();

                if (this.selectedField.CtlProps==null || this.selectedField.CtlProps.CtlSubType == null || this.selectedField.CtlProps.CtlSubType.trim() == '') {
                    e.sender.value(currentData[0].Id);
                    this.selectedField.CtlProps.CtlSubType = currentData[0].Id;
                }
                if (this.selectedField.CtlProps.CtlSubType == "TreeView") {
                    $('#div_' + this.fieldWhereRootClause).show();
                    $('#div_' + this.fieldSelectOnlyLeaves).show();
                }
                else {
                    $('#div_' + this.fieldWhereRootClause).hide();
                    $('#div_' + this.fieldSelectOnlyLeaves).hide();
                }

                if (isCustom) {
                    if (this.selectedField.CtlProps.CtlSubType == "MultiSelect") {
                        this._showMultiSelectOptions();
                    } else {
                        this._hideMultiSelectOptions();
                    }
                }
            }
        });

        if (this.selectedField.CtlProps != null && this.selectedField.CtlProps.CtlSubType != null && this.selectedField.CtlProps.CtlSubType.length > 0) {
            $('#' + this.fieldCtlSubType).data('kendoComboBox').value(this.selectedField.CtlProps.CtlSubType);

            if (isCustom) {
                if (this.selectedField.CtlProps.CtlSubType == "MultiSelect") {
                    this._showMultiSelectOptions();
                } else {
                    this._hideMultiSelectOptions();
                }
            }

            if (this.selectedField.CtlProps.CtlSubType == "TreeView") {
                if (this.selectedField.CtlProps.SelectOnlyLeaves == null) {
                    this.selectedField.CtlProps.SelectOnlyLeaves = false;
                }

                $("#" + this.fieldSelectOnlyLeaves).kendoSwitch({
                    messages: {
                        checked: this._getResource('SWITCH_ON'),
                        unchecked: this._getResource('SWITCH_OFF')
                    },
                    checked: this.selectedField.CtlProps.SelectOnlyLeaves,
                    change: (e) => {
                        this.selectedField.CtlProps.SelectOnlyLeaves = e.checked;

                        this._updateDroppable();
                        this._updatePreview();
                    }
                });
            }
        }

        if (this.selectedField.SqlWhereRoot != null && this.selectedField.SqlWhereRoot.length > 0) {
            $('#' + this.fieldWhereRootClause).val(this.selectedField.SqlWhereRoot);
        }

        $('#' + this.fieldWhereRootClause).on('focusout', () => {
            let fieldWhereRootClauseValue = $('#' + this.fieldWhereRootClause).val();
            this.selectedField.SqlWhereRoot = fieldWhereRootClauseValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.selectedField.SqlWhere != null && this.selectedField.SqlWhere.length > 0) {
            $('#' + this.fieldWhereClause).val(this.selectedField.SqlWhere);
        }

        $('#' + this.fieldWhereClause).on('focusout', () => {
            let fieldWhereClauseValue = $('#' + this.fieldWhereClause).val();
            this.selectedField.SqlWhere = fieldWhereClauseValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.selectedField.Rows != null) {
            $('#' + this.fieldRows).val(this.selectedField.Rows);
        }

        $('#' + this.fieldRows).on('focusout', () => {
            let fieldRowsValue = $('#' + this.fieldRows).val();
            this.selectedField.Rows = fieldRowsValue;
            this._updateDroppable();
            this._updatePreview();
        });

        if (this.selectedField.SqlOrderBy != null && this.selectedField.SqlOrderBy.length > 0) {
            $('#' + this.fieldOrderByClause).val(this.selectedField.SqlOrderBy);
        }

        $('#' + this.fieldOrderByClause).on('focusout', () => {
            let fieldOrderByClauseValue = $('#' + this.fieldOrderByClause).val();
            this.selectedField.SqlOrderBy = fieldOrderByClauseValue;
            this._updateDroppable();
            this._updatePreview();
        });
    }

    _showMultiSelectOptions() {
        $('#' + this.ctlCustomTypeSpecifics)[0].innerHTML = this._getCustomMultiselectOptionsTemplate();

        $('#' + this.fieldIdEntityMToN).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntityMToN).parent()
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetEntity?filter=' + $('#' + this.fieldIdEntityMToN).data('kendoComboBox').text();
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.IdEntityMToN = this.getNumber(value);
                $('#' + this.fieldIdEntityFieldM).data('kendoComboBox').dataSource.read();
                $('#' + this.fieldIdEntityFieldN).data('kendoComboBox').dataSource.read();
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntityMToN != null) {
            $('#' + this.fieldIdEntityMToN).data('kendoComboBox').value(this.selectedField.IdEntityMToN);
        }

        $('#' + this.fieldIdEntityFieldM).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntityFieldM).parent()
            },
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFields?id=' + $('#' + this.fieldIdEntityMToN).data('kendoComboBox').value();
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.IdEntityFieldM = this.getNumber(value);
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntityFieldM != null) {
            $('#' + this.fieldIdEntityFieldM).data('kendoComboBox').value(this.selectedField.IdEntityFieldM);
        }

        $('#' + this.fieldIdEntityFieldN).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldIdEntityFieldN).parent()
            },
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFields?id=' + $('#' + this.fieldIdEntityMToN).data('kendoComboBox').value();
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.IdEntityFieldN = this.getNumber(value);
                this._updateDroppable();
                this._updatePreview();
            }
        });

        if (this.selectedField.IdEntityFieldN != null) {
            $('#' + this.fieldIdEntityFieldN).data('kendoComboBox').value(this.selectedField.IdEntityFieldN);
        }
    }

    _hideMultiSelectOptions() {
        $('#' + this.ctlCustomTypeSpecifics)[0].innerHTML = '';
        this.selectedField.IdEntityMToN = null
        this.selectedField.IdEntityFieldM = null;
        this.selectedField.IdEntityFieldN = null;
    }

    _getConfiguredControlTriggers() {
        let data = [];

        let item = $('#' + this.layoutTree).data("kendoTreeView").dataSource.data()[0];

        this._getConfiguredControlTrigger(item, data);

        return data;
    }

    _getConfiguredControlTrigger(item, data) {
        if ((item.CtlType == 'ComboBox' || item.CtlType == 'Switch' || item.CtlType == 'IntegerTextBox' || item.CtlType == 'GeomPicker' || item.CtlType == 'RichText' || item.CtlType == 'NumericTextBox' || item.CtlType == 'TextBox' || item.CtlType == 'DatePicker' || item.CtlType == 'DateTimePicker') && this.selectedField.Guid != item.Guid) {
            data.push({ Id: item.Guid, Name: item.Label + (item.EntityField != null ? '(' + item.EntityField.FieldName + ')' : '')});
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._getConfiguredControlTrigger(child, data);
            });
        }
    }

    _getConfiguredComboBoxes() {
        let data = [];

        let item = $('#' + this.layoutTree).data("kendoTreeView").dataSource.data()[0];

        this._getConfiguredComboBox(item, data);

        return data;
    }

    _getConfiguredComboBox(item, data) {
        if ((item.CtlType == 'ComboBox' || item.CtlType == 'IntegerTextBox') && this.selectedField.Guid != item.Guid) {
            data.push({ Id: item.Guid, Name: item.Label + (item.EntityField != null ? '(' + item.EntityField.FieldName + ')' : '') });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._getConfiguredComboBox(child, data);
            });
        }
    }

    _setPlatform(ctl, value) {
        var val = null;
        if (value != null) {
            val = value.split(",");
        }
        else {
            val = [];
            val.push("ALL");
        }
        ctl.value(val);
    }

    _getPlatform(ctl) {
        if (ctl == null) {
            return null;
        }
        var val = ctl.value();
        if (val == null || val.length == 0) {
            return null;
        }
        if (val == "ALL") {
            return null;
        }

        return val.join(",");
    }

    _platform_onChange(e) {
        var ctl = e.sender;
        var val = ctl.value();
        var all = false;
        if (val != null && (val.length == 0 || val[val.length - 1] == "ALL")) {
            all = true;
        }
        if (val == null) {
            all = true;
        }
        if (all) {
            var data = ctl.dataSource.data();
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id == "ALL") {
                    ctl.value(["ALL"]);
                    break;
                }
            }
        }
        else {
            //daca exista All trebuie sa il scot. probabil nu este ultimul (caz tratat mai sus)
            var newVal = [];
            var found = false;
            for (var i = 0; i < val.length; i++) {
                if (val[i] == "ALL") {
                    found = true;
                }
                else {
                    newVal.push(val[i]);
                }
            }
            if (found) {
                ctl.value(newVal);
            }
        }
    }

    _updatePreview() {
        setTimeout(() => {
            loadPreview();
        }, 0);
        //return new Promise((resolve, reject) => {
        //    loadPreview();
        //    resolve();
        //});
    }

    _updateDroppable() {
        $('.tree-UILayoutDto').droppable({
            accept: (draggedElement) => {
                return draggedElement.is('#tab-drag,#group-drag,#paragraph-drag,#sublist-drag,#mapview-drag,.field-choice-item,#customfield-drag');
            },
            drop: function (event, ui) {
                var parentUid = $(this).closest('.k-treeview-item').attr('data-uid');
                var childSelector = ui.draggable;
                formFieldsControl._addLayoutItem(parentUid, childSelector);
            },
            tolerance: "pointer"
        });

        $('.tree-UITabControlDto').droppable({
            accept: (draggedElement) => {
                return draggedElement.is('#page-drag');
            },
            drop: function (event, ui) {
                var parentUid = $(this).closest('.k-treeview-item').attr('data-uid');
                var childSelector = ui.draggable;
                formFieldsControl._addLayoutItem(parentUid, childSelector);
            },
            tolerance: "pointer"
        });

        $('.tree-UIGroupDto').droppable({
            accept: (draggedElement) => {
                return draggedElement.is('#tab-drag,#group-drag,#paragraph-drag,#sublist-drag,#mapview-drag,.field-choice-item,#customfield-drag');
            },
            drop: function (event, ui) {
                var parentUid = $(this).closest('.k-treeview-item').attr('data-uid');
                var childSelector = ui.draggable;
                formFieldsControl._addLayoutItem(parentUid, childSelector);
            },
            tolerance: "pointer"
        });

        $('.tree-UIParagraphDto').droppable({
            accept: (draggedElement) => {
                return draggedElement.is('#tab-drag,#group-drag,#paragraph-drag,#sublist-drag,#mapview-drag,.field-choice-item,#customfield-drag');
            },
            drop: function (event, ui) {
                var parentUid = $(this).closest('.k-treeview-item').attr('data-uid');
                var childSelector = ui.draggable;
                formFieldsControl._addLayoutItem(parentUid, childSelector);
            },
            tolerance: "pointer"
        });

        $('.tree-UITabPageDto').droppable({
            accept: (draggedElement) => {
                return draggedElement.is('#tab-drag,#group-drag,#paragraph-drag,#sublist-drag,#mapview-drag,.field-choice-item,#customfield-drag');
            },
            drop: function (event, ui) {
                var parentUid = $(this).closest('.k-treeview-item').attr('data-uid');
                var childSelector = ui.draggable;
                formFieldsControl._addLayoutItem(parentUid, childSelector);
            },
            tolerance: "pointer"
        });
    }

    _addLayoutItem(parentUid, childSelector) {
        return new Promise((resolve, reject) => {
            let childId = childSelector.attr('id');
            let childType = '';

            switch (childId) {
                case 'tab-drag': childType = 'UITabControlDto';
                    break;
                case 'page-drag': childType = 'UITabPageDto';
                    break;
                case 'group-drag': childType = 'UIGroupDto';
                    break;
                case 'paragraph-drag': childType = 'UIParagraphDto';
                    break;
                case 'sublist-drag': childType = 'UISublistDto';
                    break;
                case 'mapview-drag': childType = 'UIMapViewDto';
                    break;
                case 'customfield-drag': childType = 'UICustomFieldControlDto';
                    break;
                default: childType = 'UIFieldControlDto';
                    break;
            }

            let item = {
                TypeName: childType,
                Id: 0
            }

            if (childType == 'UIFieldControlDto') {
                item.ClassName = 'mb-3';
                item.IdEntityField = childSelector.attr('field-id');
                item.EntityField = this.entityFields.filter(row => { return row.Id == item.IdEntityField })[0];
                item.DataType = childSelector.attr('field-type');
                item.Name = item.EntityField.FieldName;

                switch (item.DataType) {
                    case 'BOOLEAN':
                    case 'BOOLINT': item.CtlType = 'Switch';
                        break;
                    case 'INTEGER': {
                        if (item.EntityField.DataSubType == 'FOREIGN_KEY') {
                            item.CtlType = 'ComboBox';
                        } else {
                            item.CtlType = 'IntegerTextBox';
                        }
                    }
                        break;
                    case 'NUMERIC': item.CtlType = 'NumericTextBox';
                        break;
                    case 'DATE': item.CtlType = 'DatePicker';
                        break;
                    case 'TIMESTAMP': item.CtlType = 'DateTimePicker';
                        break;
                    case 'BYTEA': item.CtlType = 'File';
                        break;
                    case 'STRING': item.CtlType = 'TextBox';
                        break;
                    case 'GEOMETRY': {
                        item.CtlType = 'GeomPicker';
                        item.CtlProps = { CtlSubType: 'ModalMap' };
                    }
                        break;
                }

                let fieldLabel = "";

                if (item.EntityField.FieldName != null && item.EntityField.FieldName.length > 0) {
                    fieldLabel = this._handleInitialFieldName(item.EntityField.FieldName);
                }

                item.Label = fieldLabel;
                item.Description = item.EntityField.Description != null ? item.EntityField.Description : null;
                item.LayoutCols = 6;
            } else if (childType == 'UIGroupDto') {
                item.Collapsed = false;
                item.LayoutCols = 12;
            } else {
                item.LayoutCols = 12;
            }

            if (childType == 'UIGroupDto') {
                item.Collapsable = true;
                item.Collapsed = false;
                item.Text = this._getResource(childType);
            } else if (childType == 'UITabPageDto') {
                item.Text = this._getResource(childType);
            }

            item.Guid = this._generateUUID();
            item.UniqueClientId = item.Guid;

            let parentNode = $('#' + this.layoutTree).data("kendoTreeView").findByUid(parentUid);

            $('#' + this.layoutTree).data("kendoTreeView").append(item, parentNode);

            this._updateDroppable();
            this._updatePreview();
        });
    }

    _handleInitialFieldName(label) {
        let tuples = label.toLowerCase().replaceAll('id_z_', '').replaceAll('id_d_', '').split('_');
        let processedTuples = [];

        tuples.forEach(tuple => {
            let preprocessed = tuple.trim();
            let processed = preprocessed.charAt(0).toUpperCase() + preprocessed.slice(1);
            processedTuples.push(processed);
        });

        return processedTuples.join(' ');
    }

    _removeItem(evt, element) {
        evt.stopPropagation();
        let selection = $(element).closest('[role="treeitem"]');

        $('#' + this.layoutTree).data('kendoTreeView').remove(selection);

        this._updateDroppable();
        this._updatePreview();
    }

    _filterTree() {
        let searchFilter = {
            field: "Name",
            operator: "contains",
            value: $('#' + this.layoutFilter).val()
        };

        if ($('#' + this.layoutFilter).val().trim() == '') {
            searchFilter = {};
        }

        $('#' + this.layoutTree).data("kendoTreeView").dataSource.filter(searchFilter);
        this._updateDroppable();
    }

    _initOptions() {
        $('#' + this.optionsContainer)[0].innerHTML = this._getOptionsTemplate();

        let entityFieldsUrl = rootUrl + 'Entity/GetFields?id=' + this.entityId;

        $.ajax({
            type: "GET",
            url: entityFieldsUrl,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this.entityFields = result;
                this._initEntityFields();
            },
            error: (e) => {
                toastr.error(e.responseText, this._getResource('GetFieldsError'));
            }
        });

        $('#tab-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#page-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UITabControlDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UITabControlDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#group-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#paragraph-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#sublist-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#mapview-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        $('#customfield-drag').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });

        addHelp();
    }

    _initEntityFields() {
        $('#' + this.fieldsContainer)[0].innerHTML = this._getEntityFieldsTemplate();

        $('.field-choice-item').draggable({
            greedy: true,
            tolerance: "pointer",
            helper: 'clone',
            revert: 'invalid',
            appendTo: 'body',
            start: function (event, ui) {
                ui.helper.css({
                    position: 'absolute'
                });
                $('.tree-UILayoutDto').parent().addClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().addClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().addClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().addClass('k-state-highlighted');
                $(this).css('visibility', 'hidden');
            },
            stop: function (event, ui) {
                $('.tree-UILayoutDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIGroupDto').parent().removeClass('k-state-highlighted');
                $('.tree-UITabPageDto').parent().removeClass('k-state-highlighted');
                $('.tree-UIParagraphDto').parent().removeClass('k-state-highlighted');
                $(this).css('visibility', 'visible');
            }
        });
    }

    _tabOnClick(id) {
        $('#' + id).parent().parent().find('.nav-link').removeClass('active');
        $('#' + id).parent().parent().find('.nav-link').attr('aria-selected', 'false');
        $('#' + id + '-anchor').addClass('active');
        $('#' + id + '-anchor').attr('aria-selected', 'true');

        $('#' + id).addClass('show');
        $('#' + id).addClass('active');

        $('#' + id).siblings().removeClass('show');
        $('#' + id).siblings().removeClass('active');
    }

    _addLayoutTemplateEvents() {
        $('#' + this.fieldStyle).on('click', () => {
            $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

            let htmlWindowOptions = {
                draggable: false,
                resizable: true,
                width: "50%",
                height: "fit-content",
                title: this._getResource('Style'),
                modal: true,
                close: () => { this._closeHtmlTemplateWindow(); }
            };

            $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);

            if ($('body')[0].classList.contains('mod-skin-dark')) {
                $('.k-window').addClass('mod-skin-dark');
            }

            this._initStyleLayoutTemplate();
            $('#' + this.layoutTemplateInner).data("kendoWindow").center();
        });

        $('#' + this.fieldHtmlAttributes).on('click', () => {
            $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

            let htmlWindowOptions = {
                draggable: false,
                resizable: true,
                width: "50%",
                height: "fit-content",
                title: this._getResource('HtmlAttributes'),
                modal: true,
                close: () => { this._closeHtmlTemplateWindow(); }
            };

            $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);

            if ($('body')[0].classList.contains('mod-skin-dark')) {
                $('.k-window').addClass('mod-skin-dark');
            }

            this._initHtmlAttributesLayoutTemplate();
            $('#' + this.layoutTemplateInner).data("kendoWindow").center();
        });
    }

    _closeHtmlTemplateWindow() {
        $('#' + this.layoutTemplateInner).data("kendoWindow").destroy();
    }

    _initUiLayoutStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInner = ace.edit(this.fieldStyleInner, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleInner != null) {
                this.styleInner.setValue(style.styleInner);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }
        }
    }

    _initUiTabStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.stylePageButton = ace.edit(this.fieldStylePageButton, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.stylePageLink = ace.edit(this.fieldStylePageLink, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.stylePageWrapper = ace.edit(this.fieldStylePageWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.stylePageButton != null) {
                this.stylePageButton.setValue(style.stylePageButton);
            }

            if (style.stylePageLink != null) {
                this.stylePageLink.setValue(style.stylePageLink);
            }

            if (style.stylePageWrapper != null) {
                this.stylePageWrapper.setValue(style.stylePageWrapper);
            }
        }
    }

    _initUiTabPageStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }
        }
    }

    _initUiGroupStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleCard = ace.edit(this.fieldStyleCard, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleCardHeader = ace.edit(this.fieldStyleCardHeader, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleCardHeaderLabel = ace.edit(this.fieldStyleCardHeaderLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleCardInner = ace.edit(this.fieldStyleCardInner, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleCard != null) {
                this.styleCard.setValue(style.styleCard);
            }

            if (style.styleCardHeader != null) {
                this.styleCardHeader.setValue(style.styleCardHeader);
            }

            if (style.styleCardHeaderLabel != null) {
                this.styleCardHeaderLabel.setValue(style.styleCardHeaderLabel);
            }

            if (style.styleCardInner != null) {
                this.styleCardInner.setValue(style.styleCardInner);
            }
        }
    }

    _initUiParagraphStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });


        this.styleLabel = ace.edit(this.fieldStyleLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInner = ace.edit(this.fieldStyleInner, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleLabel != null) {
                this.styleLabel.setValue(style.styleLabel);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }

            if (style.styleInner != null) {
                this.styleInner.setValue(style.styleInner);
            }
        }
    }

    _initUiSublistStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });


        this.styleLabel = ace.edit(this.fieldStyleLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInner = ace.edit(this.fieldStyleInner, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleLabel != null) {
                this.styleLabel.setValue(style.styleLabel);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }

            if (style.styleInner != null) {
                this.styleInner.setValue(style.styleInner);
            }
        }
    }

    _initUiMapViewStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });


        this.styleLabel = ace.edit(this.fieldStyleLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInner = ace.edit(this.fieldStyleInner, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleLabel != null) {
                this.styleLabel.setValue(style.styleLabel);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }

            if (style.styleInner != null) {
                this.styleInner.setValue(style.styleInner);
            }
        }
    }

    _initUiCustomFieldStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInput = ace.edit(this.fieldStyleInput, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleLabel = ace.edit(this.fieldStyleLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleInput != null) {
                this.styleInput.setValue(style.styleInput);
            }

            if (style.styleLabel != null) {
                this.styleLabel.setValue(style.styleLabel);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }
        }
    }

    _initUiFieldStyle() {
        this.styleWrapper = ace.edit(this.fieldStyleWrapper, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleInput = ace.edit(this.fieldStyleInput, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleLabel = ace.edit(this.fieldStyleLabel, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.styleDescription = ace.edit(this.fieldStyleDescription, {
            mode: "ace/mode/css",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (this.selectedField.Style != null && this.selectedField.Style != '') {
            let style = JSON.parse(this.selectedField.Style);

            if (style.styleWrapper != null) {
                this.styleWrapper.setValue(style.styleWrapper);
            }

            if (style.styleInput != null) {
                this.styleInput.setValue(style.styleInput);
            }

            if (style.styleLabel != null) {
                this.styleLabel.setValue(style.styleLabel);
            }

            if (style.styleDescription != null) {
                this.styleDescription.setValue(style.styleDescription);
            }
        }
    }

    _saveLayoutStyle() {
        switch (this.selectedField.TypeName) {
            case 'UILayoutDto': this._saveUiLayoutStyle();
                break;
            case 'UITabControlDto': this._saveUiTabStyle();
                break;
            case 'UITabPageDto': this._saveUiTabPageStyle();
                break;
            case 'UIGroupDto': this._saveUiGroupStyle();
                break;
            case 'UIParagraphDto': this._saveUiParagraphStyle();
                break;
            case 'UISublistDto': this._saveUiSublistStyle();
                break;
            case 'UIMapViewDto': this._saveUiMapViewStyle();
                break;
            case 'UIFieldControlDto': this._saveUiFieldStyle();
                break;
            case 'UICustomFieldControlDto': this._saveUiCustomFieldStyle();
                break;
        }

        this._closeHtmlTemplateWindow();
        this._updateDroppable();
        this._updatePreview();
    }

    _saveUiLayoutStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleInner = this.styleInner.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiTabStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.stylePageButton = this.stylePageButton.getValue();
        styleJson.stylePageLink = this.stylePageLink.getValue();
        styleJson.stylePageWrapper = this.stylePageWrapper.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiTabPageStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiGroupStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleCard = this.styleCard.getValue();
        styleJson.styleCardHeader = this.styleCardHeader.getValue();
        styleJson.styleCardHeaderLabel = this.styleCardHeaderLabel.getValue();
        styleJson.styleCardInner = this.styleCardInner.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiParagraphStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleLabel = this.styleLabel.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();
        styleJson.styleInner = this.styleInner.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiSublistStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleLabel = this.styleLabel.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();
        styleJson.styleInner = this.styleInner.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiMapViewStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleLabel = this.styleLabel.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();
        styleJson.styleInner = this.styleInner.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiFieldStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleInput = this.styleInput.getValue();
        styleJson.styleLabel = this.styleLabel.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveUiCustomFieldStyle() {
        let styleJson = {};

        styleJson.styleWrapper = this.styleWrapper.getValue();
        styleJson.styleInput = this.styleInput.getValue();
        styleJson.styleLabel = this.styleLabel.getValue();
        styleJson.styleDescription = this.styleDescription.getValue();

        this.selectedField.Style = JSON.stringify(styleJson);
    }

    _saveLayoutHtmlAttributes() {
        let result = {};

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            let attribute = $('#attribute_name_' + i).val();
            let value = $('#attribute_value_' + i).val();

            if (attribute != null && attribute.trim() != '' & value != null && value.trim() != '') {
                result[attribute] = value;
            }
        }

        this.selectedField.HtmlAttributes = result;

        this._closeHtmlTemplateWindow();
        this._updateDroppable();
        this._updatePreview();
    }

    /* Utilities */

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _generateUniqueIds(item) {
        if (item.Guid == null) {
            item.Guid = this._generateUUID();
            item.UniqueClientId = item.Guid;
        } else {
            item.UniqueClientId = 'entity-form-item-' + item.Guid;
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._generateUniqueIds(child);
            });
        }
    }

    _openRefList(selector) {
        let value = $('#' + selector).data('kendoComboBox').value();

        if (value != null) {
            window.open(rootUrl + 'EntityList/EntityListForm?id=' + value, "_blank");
        }
    }

    _openRefMap(selector) {
        let value = $('#' + selector).data('kendoComboBox').value();

        if (value != null) {
            window.open(rootUrl + 'Map/MapConfigRun?id=' + value, "_blank");
        }
    }

    /* Templates */

    _initHtmlAttributesLayoutTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group" style="text-align: center;">
                                    <label class="form-label">` + this._getResource('HtmlAttributeName') + `</label>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3" style="text-align: center;">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('HtmlAttributeValue') + `</label>
                                </div>
                            </div>
                        </div>`;

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            template += `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_name_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="text-align: center; line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                    <label class="form-label">=</label>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_value_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                        </div>`;
        }

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                        <button class="btn btn-secondary ml-auto mt-3" onclick="formFieldsControl._closeHtmlTemplateWindow()" title="` + this._getResource('Cancel') + `" type="button">` + this._getResource('Cancel') + `</button>
                        <button class="btn btn-primary ml-2 mt-3" onclick="formFieldsControl._saveLayoutHtmlAttributes()" title="` + this._getResource('Save') + `" type="button">` + this._getResource('Save') + `</button>
                    </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        if (this.selectedField.HtmlAttributes != null) {
            let keys = Object.keys(this.selectedField.HtmlAttributes);
            let counter = 0;

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    $('#attribute_name_' + counter).val(keys[i]);
                    $('#attribute_value_' + counter).val(this.selectedField.HtmlAttributes[keys[i]]);
                    counter++;
                }
            }
        }
    }

    _getUiCustomFieldStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInputName') + `</label>
                                    <div id="` + this.fieldStyleInput + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleLabelName') + `</label>
                                    <div id="` + this.fieldStyleLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiFieldStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInputName') + `</label>
                                    <div id="` + this.fieldStyleInput + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleLabelName') + `</label>
                                    <div id="` + this.fieldStyleLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiSublistStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleLabelName') + `</label>
                                    <div id="` + this.fieldStyleLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInnerName') + `</label>
                                    <div id="` + this.fieldStyleInner + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiMapViewStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleLabelName') + `</label>
                                    <div id="` + this.fieldStyleLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInnerName') + `</label>
                                    <div id="` + this.fieldStyleInner + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiParagraphStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleLabelName') + `</label>
                                    <div id="` + this.fieldStyleLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInnerName') + `</label>
                                    <div id="` + this.fieldStyleInner + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiGroupStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleCardName') + `</label>
                                    <div id="` + this.fieldStyleCard + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleCardHeaderName') + `</label>
                                    <div id="` + this.fieldStyleCardHeader + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleCardHeaderLabelName') + `</label>
                                    <div id="` + this.fieldStyleCardHeaderLabel + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleCardInnerName') + `</label>
                                    <div id="` + this.fieldStyleCardInner + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiTabStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StylePageButtonName') + `</label>
                                    <div id="` + this.fieldStylePageButton + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StylePageLinkName') + `</label>
                                    <div id="` + this.fieldStylePageLink + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StylePageWrapperName') + `</label>
                                    <div id="` + this.fieldStylePageWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiTabPageStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getUiLayoutStyleTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleWrapperName') + `</label>
                                    <div id="` + this.fieldStyleWrapper + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleInnerName') + `</label>
                                    <div id="` + this.fieldStyleInner + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getResource('StyleDescriptionName') + `</label>
                                    <div id="` + this.fieldStyleDescription + `" class="form-control" style="height: 6rem;"></div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _initStyleLayoutTemplate() {
        let template = ``;

        switch (this.selectedField.TypeName) {
            case 'UILayoutDto': template = this._getUiLayoutStyleTemplate();
                break;
            case 'UITabControlDto': template = this._getUiTabStyleTemplate();
                break;
            case 'UITabPageDto': template = this._getUiTabPageStyleTemplate();
                break;
            case 'UIGroupDto': template = this._getUiGroupStyleTemplate();
                break;
            case 'UIParagraphDto': template = this._getUiParagraphStyleTemplate();
                break;
            case 'UISublistDto': template = this._getUiSublistStyleTemplate();
                break;
            case 'UIMapViewDto': template = this._getUiMapViewStyleTemplate();
                break;
            case 'UIFieldControlDto': template = this._getUiFieldStyleTemplate();
                break;
            case 'UICustomFieldControlDto': template = this._getUiCustomFieldStyleTemplate();
                break;
        }

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                        <button class="btn btn-secondary ml-auto mt-3" onclick="formFieldsControl._closeHtmlTemplateWindow()" title="` + this._getResource('Cancel') + `" type="button">` + this._getResource('Cancel') + `</button>
                        <button class="btn btn-primary ml-2 mt-3" onclick="formFieldsControl._saveLayoutStyle()" title="` + this._getResource('Save') + `" type="button">` + this._getResource('Save') + `</button>
                    </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        switch (this.selectedField.TypeName) {
            case 'UILayoutDto': this._initUiLayoutStyle();
                break;
            case 'UITabControlDto': this._initUiTabStyle();
                break;
            case 'UITabPageDto': this._initUiTabPageStyle();
                break;
            case 'UIGroupDto': this._initUiGroupStyle();
                break;
            case 'UIParagraphDto': this._initUiParagraphStyle();
                break;
            case 'UISublistDto': this._initUiSublistStyle();
                break;
            case 'UIMapViewDto': this._initUiMapViewStyle();
                break;
            case 'UIFieldControlDto': this._initUiFieldStyle();
                break;
            case 'UICustomFieldControlDto': this._initUiCustomFieldStyle();
                break;
        }
    }

    _getOptionsTemplate() {
        let template = `<div class="options-inner-wrapper">
                            <div class="options-layout-choices" style="width: 100%;">
                                <div class="fields-choices-title" style="margin-top: 1rem;">` + this._getResource('ControlsTitle') + `</div>
                                <div class="options-layout-choices-inner pt-2 pb-2" style="width: 100%; justify-content: flex-start;">
                                    <div title="` + this._getResource('Tab') + `" id="tab-drag" choice-type="UITabControlDto" class="options-drag ml-2"><button class="btn-primary fal fa-browser layout-choice-button m-0" title="` + this._getResource('Tab') + `"></button></div>
                                    <div title="` + this._getResource('TabPage') + `" id="page-drag" choice-type="UITabPageDto" class="options-drag ml-2"><button class="btn-primary fal fa-file-alt layout-choice-button m-0" title="` + this._getResource('TabPage') + `"></button></div>
                                    <div title="` + this._getResource('Group') + `" id="group-drag" choice-type="UIGroupDto" class="options-drag ml-2"><button class="btn-primary fal fa-object-group layout-choice-button m-0" title="` + this._getResource('Group') + `"></button></div>
                                    <div title="` + this._getResource('Paragraph') + `" id="paragraph-drag" choice-type="UIParagraphDto" class="options-drag ml-2"><button class="btn-primary fal fa-rectangle-landscape layout-choice-button m-0" title="` + this._getResource('Paragraph') + `"></button></div>
                                </div>
                            </div>
                            <div class="options-layout-choices" style="width: 100%;">
                                <div class="fields-choices-title">` + this._getResource('Controls') + `</div>
                                <div class="options-layout-choices-inner pt-2 pb-2" style="width: 100%; justify-content: flex-start;">
                                    <div title="` + this._getResource('Sublist') + `" id="sublist-drag" choice-type="UISublistDto" class="options-drag ml-2" help-key="EntityForm.Field.Sublist"><button class="btn-primary fal fa-columns layout-choice-button m-0" title="` + this._getResource('Sublist') + `"></button></div>
                                    <div title="` + this._getResource('MapView') + `" id="mapview-drag" choice-type="UIMapViewDto" class="options-drag ml-2" help-key="EntityForm.Field.MapView"><button class="btn-primary fal fa-map-marked-alt layout-choice-button m-0" title="` + this._getResource('MapView') + `"></button></div>
                                    <div title="` + this._getResource('CustomField') + `" id="customfield-drag" choice-type="UICustomFieldDto" class="options-drag ml-2" help-key="EntityForm.Field.CustomField"><button class="btn-primary fal fa-code layout-choice-button m-0" title="` + this._getResource('CustomField') + `"></button></div>
                                </div>
                            </div>
                            <div class="options-fields-choices" style="width: 100%;">
                                <div class="fields-choices-title">` + this._getResource('FieldsTitle') + `</div>
                                <div class="fields-choices-inner pl-3 pt-2 pb-2" id="` + this.fieldsContainer + `" style="max-height: 30.5rem;"></div>
                            </div>
                        </div>`;

        return template;
    }

    _getEntityFieldsTemplate() {
        let template = ``;

        this.entityFields.forEach(entityField => {
            let fieldIcon = '';

            switch (entityField.DataType) {
                case 'STRING': fieldIcon = 'abc';
                    break;
                case 'NUMERIC': fieldIcon = '123';
                    break;
                case 'INTEGER': fieldIcon = '123';
                    break;
                case 'DATE': fieldIcon = 'today';
                    break;
                case 'TIMESTAMP': fieldIcon = 'today';
                    break;
                case 'GEOMETRY': fieldIcon = 'polyline';
                    break;
                case 'BYTEA': fieldIcon = 'memory';
                    break;
                case 'BOOLEAN': fieldIcon = 'check_box';
                    break;
                case 'BOOLINT': fieldIcon = 'check_box';
                    break;
                default: fieldIcon = 'abc';
                    break;
            }

            template += `<div class="field-choice-item" field-name=` + entityField.FieldName + ` field-type="` + entityField.DataType + `" field-id="` + entityField.Id + `" style="display: inline-flex; flex-wrap: nowrap; width: 100% !important;">
                            <span class="material-symbols-rounded field-choice-item-symbol">` + fieldIcon + `</span>
                            <span class="field-choice-item-name">` + entityField.FieldName + `</span>
                        </div>`;
        });

        return template;
    }

    _getTreeIconTemplate(item) {
        if (item.TypeName != 'UIFieldControlDto') {
            let template = '<span class="';
            switch (item.TypeName) {
                case 'UILayoutDto': template += 'fal fa-credit-card-front';
                    break;
                case 'UITabControlDto': template += 'fal fa-browser';
                    break;
                case 'UITabPageDto': template += 'fal fa-file-alt';
                    break;
                case 'UIGroupDto': template += 'fal fa-object-group';
                    break;
                case 'UIParagraphDto': template += 'fal fa-rectangle-landscape';
                    break;
                case 'UISublistDto': template += 'fal fa-columns';
                    break;
                case 'UIMapViewDto': template += 'fal fa-map-marked-alt';
                    break;
                case 'UICustomFieldControlDto': template += 'fal fa-code';
                    break;
            }
            template += '"></span>';

            return template;
        } else {
            let template = '<span class="material-symbols-rounded tree-material-symbol" entity-field-id="' + item.IdEntityField + '">';

            switch (item.EntityField.DataType) {
                case 'STRING': template += 'abc';
                    break;
                case 'NUMERIC': template += '123';
                    break;
                case 'INTEGER': template += '123';
                    break;
                case 'DATE': template += 'today';
                    break;
                case 'TIMESTAMP': template += 'today';
                    break;
                case 'GEOMETRY': template += 'polyline';
                    break;
                case 'BYTEA': template += 'memory';
                    break;
                case 'BOOLEAN': template += 'check_box';
                    break;
                case 'BOOLINT': template += 'check_box';
                    break;
                default: template += 'abc';
                    break;
            }

            template += '</span>';

            return template;
        }
    }

    _getRemoveIconTemplate(item) {
        let template = '';

        if (item.TypeName != 'UILayoutDto') {
            template = '<div class="tree-item-remove fal fa-trash-alt" onclick="formFieldsControl._removeItem(event, this)" style="margin-left: 1rem; line-height: 1.2rem; width: 1.2rem; text-align: center; color: inherit;"></div>'
        }

        return template;
    }

    _getTreeItemTemplate(item) {
        let template = '';
        let isInvalid = item.InvalidProperties != null && item.InvalidProperties.length > 0;
        if (item.TypeName == 'UIFieldControlDto') {
            let itemName = item.Name;

            if (item.Name != null && item.Name.lastIndexOf('_') > 0) {
                itemName = item.Name;
            } else {
                itemName = item.EntityField.FieldName;
            }

            return this._getResource(item.TypeName) + ' (<span ' + (isInvalid ? '' : 'style="color:#4679cc;"') + '>' + itemName + '</span>)';
        } else if (item.Name != null && item.Name != '') {
            return this._getResource(item.TypeName) + ' (<span ' + (isInvalid ? '' : 'style = "color:#4679cc;"') + '>' + item.Name + '</span>)';
        } else {
            return this._getResource(item.TypeName);
        }

        return template;
    }

    _getCustomMultiselectOptionsTemplate() {
        return `<div class="form-row">
                    <div class="col-sm-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">` + this._getResource('IdEntityMToN') + `</label>
                            <div id="` + this.fieldIdEntityMToN + `" class="form-control"></div>
                            <span id="IdEntityMToN-validation" class="field-error-message"></span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">` + this._getResource('IdEntityFieldM') + `</label>
                            <div id="` + this.fieldIdEntityFieldM + `" class="form-control"></div>
                            <span id="IdEntityFieldM-validation" class="field-error-message"></span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-12 mb-3">
                        <div class="form-group">
                            <label class="form-label">` + this._getResource('IdEntityFieldN') + `</label>
                            <div id="` + this.fieldIdEntityFieldN + `" class="form-control"></div>
                            <span id="IdEntityFieldN-validation" class="field-error-message"></span>
                        </div>
                    </div>
                </div>`;
    }

    _getCustomFieldNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem);">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Label') + `</label>
                                                        <input type="text" id="` + this.fieldLabel + `" class="form-control" autocomplete="off"/>
                                                        <span id="Label-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LoadCommand') + `</label>
                                                        <div id="` + this.fieldLoadCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandLoad-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('SaveCommand') + `</label>
                                                        <div id="` + this.fieldSaveCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandSave-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>` + (this.isFilter ? `<div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('DataType') + `</label>
                                                    <div id="` + this.fieldDataType + `" class="form-control"></div>
                                                    <span id="DataType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('CtlType') + `</label>
                                                    <div id="` + this.fieldCtlType + `" class="form-control"></div>
                                                    <span id="CtlType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('FilterOp') + `</label>
                                                    <div id="` + this.fieldOperator + `" class="form-control"></div>
                                                    <span id="FilterOp-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 mb-3" id="div_` + this.fieldSqlWhereFilter + `" style="display:none">
                                                <div class="form-group">
                                                    <label class="form-label" help-key="UIFieldControlDto.WhereClauseFilter">` + this._getResource('WhereClauseFilter') + `</label>
                                                    <input type="text" id="` + this.fieldSqlWhereFilter + `" class="form-control" autocomplete="off"/>
                                                    <span id="SqlWhereFilter-validation" class="field-error-message"></span>
                                                </div>
                                            </div>                                        
                                        </div>` : `<div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('DataType') + `</label>
                                                    <div id="` + this.fieldDataType + `" class="form-control"></div>
                                                    <span id="DataType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('CtlType') + `</label>
                                                    <div id="` + this.fieldCtlType + `" class="form-control"></div>
                                                    <span id="CtlType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                        </div>`)
                                        + `<div id="` + this.ctlTypeSpecifics + `">
                                        </div>
                                        <div id="` + this.ctlCustomTypeSpecifics + `">
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('Platforms') + `</label>
                                                    <div id="` + this.fieldPlatforms + `" class="form-control"></div>
                                                    <span id="Platforms-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('CommandNotNull') + `</label>
                                                        <div id="` + this.fieldCommandNotNull + `" class="form-control"></div>
                                                        <span id="IdXpCommandNotNull-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="mb-3 col-4" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Readonly') + `</label>
                                                        <div id="` + this.fieldReadonly + `"></div>
                                                        <span id="IsReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-8" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Hidden') + `</label>
                                                        <div id="` + this.fieldHidden + `"></div>
                                                        <span id="Hidden-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-4" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('NotNull') + `</label>
                                                        <div id="` + this.fieldMandatory + `"></div>
                                                        <span id="NotNull-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-8" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('ReadFromQr') + `</label>
                                                        <div id="` + this.fieldReadFromQr + `"></div>
                                                        <span id="ReadFromQr-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('FieldDefValue') + `</label>
                                                        <a href="javascript:void(0);" class="btn btn-field-info btn-icon fs-xl width-1 mr-1 btn-light" data-toggle="popover" data-trigger="focus" data-placement="top" data-html="true"
                                                            data-content="` + this._getResource('FieldDefValue') + `" style="line-height: 1rem;">
                                                            <i class="fal fa-question-circle color-fusion-300"></i>
                                                        </a>
                                                        <span class="k-widget k-combobox" style="width: 100%;">
                                                            <span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default k-state-hover">
                                                                <input id="` + this.fieldDefValue + `" class="k-input" type="text" readonly>
                                                                <span class="k-select btn-primary" role="button" tabindex="-1" id="` + this.fieldDefValueEdit + `">
                                                                    <span class="fal fa-function"></span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                        <span id="DefValue-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getFieldNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem);">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Label') + `</label>
                                                        <input type="text" id="` + this.fieldLabel + `" class="form-control" autocomplete="off"/>
                                                        <span id="Label-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>` + (this.isFilter ? `<div class="form-row">
                                            <div class="col-sm-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('CtlType') + `</label>
                                                    <div id="` + this.fieldCtlType + `" class="form-control"></div>
                                                    <span id="CtlType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('FilterOp') + `</label>
                                                    <div id="` + this.fieldOperator + `" class="form-control"></div>
                                                    <span id="FilterOp-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 mb-3" id="div_` + this.fieldSqlWhereFilter + `" style="display:none">
                                                <div class="form-group">
                                                    <label class="form-label" help-key="UIFieldControlDto.WhereClauseFilter">` + this._getResource('WhereClauseFilter') + `</label>
                                                    <input type="text" id="` + this.fieldSqlWhereFilter + `" class="form-control" autocomplete="off"/>
                                                    <span id="SqlWhereFilter-validation" class="field-error-message"></span>
                                                </div>
                                            </div>                                        
                                        </div>` : `<div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('CtlType') + `</label>
                                                    <div id="` + this.fieldCtlType + `" class="form-control"></div>
                                                    <span id="CtlType-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                        </div>`)
                                     + `<div id="` + this.ctlTypeSpecifics + `">
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this._getResource('Platforms') + `</label>
                                                    <div id="` + this.fieldPlatforms + `" class="form-control"></div>
                                                    <span id="Platforms-validation" class="field-error-message"></span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('CommandNotNull') + `</label>
                                                        <div id="` + this.fieldCommandNotNull + `" class="form-control"></div>
                                                        <span id="IdXpCommandNotNull-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="mb-3 col-4" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Readonly') + `</label>
                                                        <div id="` + this.fieldReadonly + `"></div>
                                                        <span id="IsReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-8" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Hidden') + `</label>
                                                        <div id="` + this.fieldHidden + `"></div>
                                                        <span id="Hidden-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-4" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('NotNull') + `</label>
                                                        <div id="` + this.fieldMandatory + `"></div>
                                                        <span id="NotNull-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-8" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('ReadFromQr') + `</label>
                                                        <div id="` + this.fieldReadFromQr + `"></div>
                                                        <span id="ReadFromQr-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('FieldDefValue') + `</label>
                                                        <a href="javascript:void(0);" class="btn btn-field-info btn-icon fs-xl width-1 mr-1 btn-light" data-toggle="popover" data-trigger="focus" data-placement="top" data-html="true"
                                                            data-content="` + this._getResource('FieldDefValue') + `" style="line-height: 1rem;">
                                                            <i class="fal fa-question-circle color-fusion-300"></i>
                                                        </a>
                                                        <span class="k-widget k-combobox" style="width: 100%;">
                                                            <span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default k-state-hover">
                                                                <input id="` + this.fieldDefValue + `" class="k-input" type="text" readonly>
                                                                <span class="k-select btn-primary" role="button" tabindex="-1" id="` + this.fieldDefValueEdit + `">
                                                                    <span class="fal fa-function"></span>
                                                                </span>
                                                            </span>
                                                        </span>
                                                        <span id="DefValue-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getInputSpecificsTemplate() {
        let template = `<div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('Format') + `</label>
                    <input type="text" id="` + this.fieldFormat + `" class="form-control" autocomplete="off"/>
                    <span id="Format-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>`;

        return template;
    }

    _getGeometryPickerSpecificsTemplate() {
        let template = `<div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('CtlSubType') + `</label>
                    <div id="` + this.fieldCtlSubType + `" class="form-control"></div>
                    <span id="CtlSubType-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('MapRef') + `</label>
                    <div id="` + this.fieldMapRef + `" class="form-control"></div>
                    <span id="MapRef-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('MinFitScale') + `</label>
                    <input type="number" id="` + this.fieldMinFitScale + `" class="form-control" autocomplete="off"/>
                    <span id="MinFitScale-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>`;

        return template;
    }

    _getComboBoxSpecificsTemplate() {
        let template = `<div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('EntitySource') + `</label>
                    <div id="` + this.fieldIdEntitySource + `" class="form-control"></div>
                    <span id="IdEntitySource-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('CtlSubType') + `</label>
                    <div id="` + this.fieldCtlSubType + `" class="form-control"></div>
                    <span id="CtlSubType-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row" id="div_` + this.fieldWhereRootClause + `" style="display:none">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label" help-key="UIFieldControlDto.WhereClauseRoot">` + this._getResource('WhereClauseRoot') + `</label>
                    <input type="text" id="` + this.fieldWhereRootClause + `" class="form-control" autocomplete="off"/>
                    <span id="SqlWhereRoot-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label" help-key="UIFieldControlDto.WhereClause">` + this._getResource('WhereClause') + `</label>
                    <input type="text" id="` + this.fieldWhereClause + `" class="form-control" autocomplete="off"/>
                    <span id="SqlWhere-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('OrderByClause') + `</label>
                    <input type="text" id="` + this.fieldOrderByClause + `" class="form-control" autocomplete="off"/>
                    <span id="SqlOrderBy-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-12 mb-3">
                <div class="form-group">
                    <label class="form-label">` + this._getResource('MaxRows') + `</label>
                    <input type="number" id="` + this.fieldRows + `" class="form-control" autocomplete="off"/>
                    <span id="Rows-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>
        <div class="form-row" id="div_` + this.fieldSelectOnlyLeaves + `" style="display:none">
            <div class="col-sm-12 mb-3">
                <div class="form-group" style="display: flex; flex-direction: row-reverse; justify-content: flex-end;">
                    <label class="form-label ml-2">` + this._getResource('SelectOnlyLeaves') + `</label>
                    <div id="` + this.fieldSelectOnlyLeaves + `"></div>
                    <span id="SelectOnlyLeaves-validation" class="field-error-message"></span>
                </div>
            </div>
        </div>`;

        return template;
    }

    _getDefValueValueTemplate() {
        let template = ``

        let dataType = 'STRING';

        if (this.selectedField.EntityField) {
            dataType = this.selectedField.EntityField.DataType;
        } else if ($('#' + this.fieldDataType).data('kendoComboBox') != null) {
            let cboxDataType = $('#' + this.fieldDataType).data('kendoComboBox').value();

            if (cboxDataType != null && cboxDataType != '') {
                dataType = cboxDataType;
            }
        }

        switch (dataType) {
            case 'STRING': template = `<input type="text" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'NUMERIC': template = `<input type="number" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'INTEGER': template = `<input type="number" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'DATE': template = `<input id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'TIMESTAMP': template = `<input id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'GEOMETRY': template = ``;
                break;
            case 'BYTEA': template = ``;
                break;
            case 'BOOLEAN': template = `<div id="` + this.fieldDefValueValue + `" style="margin-left: 0.5rem;"></div>`;
                break;
            case 'BOOLINT': template = `<div id="` + this.fieldDefValueValue + `" style="margin-left: 0.5rem;"></div>`;
                break;
            default:
                break;
        }

        return template;
    }

    _initDefValueWindow() {
        let template = `<div style="height: calc(100% - 4.5rem); overflow-x: hidden; overflow-y: auto; margin-bottom: 1rem; margin-right: 0.8rem;">
                            <div class="form-row">
                                <div class="col-xl-12 mb-3">
                                    <div class="frame-wrap mb-0">
                                        <div id="` + this.fieldDefValueType + `" class="btn-group btn-group-toggle btn-group-sm" data-toggle="buttons">`
            + (this.selectedField.EntityField == null || (this.selectedField.EntityField.DataType != 'BYTEA' && this.selectedField.EntityField.DataType != 'GEOMETRY') ? `
                                            <label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="VALUE">` + this._getResource('ValueType_Value') + `
                                            </label>
                                            <label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="TOKEN">` + this._getResource('ValueType_Token') + `
                                            </label>
                                            `: ``) +
            `<label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="SQL">` + this._getResource('ValueType_Sql') + `
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueValue + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getResource('ValueType_Value') + `</label>`
            + this._getDefValueValueTemplate() +
            `<span id="` + this.fieldDefValueValue + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueToken + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getResource('ValueType_Token') + `</label>
                                        <div id="` + this.fieldDefValueToken + `" class="form-control"></div>
                                        <span id="` + this.fieldDefValueToken + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueSql + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getResource('ValueType_Sql') + `</label>
                                        <textarea id="` + this.fieldDefValueSql + `" class="form-control"></textarea>
                                        <span id="` + this.fieldDefValueSql + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                 <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getResource('ApplyToFieldName') + `</label>
                                        <div id="` + this.fieldApplyTo + `" class="form-control"></div>
                                        <span id="` + this.fieldApplyTo + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-3">
                            <button class="btn btn-secondary ml-auto mt-3" onclick="formFieldsControl._closeDefValueWindow()" title="` + this._getResource('CancelChanges') + `" type="button">` + this._getResource('Cancel') + `</button>
                            <button class="btn btn-primary ml-2 mt-3" onclick="formFieldsControl._saveDefValue()" title="` + this._getResource('SaveChanged') + `" type="button">` + this._getResource('Save') + `</button>
                        </div>`;

        $('#' + this.fieldsDatabaseItem)[0].innerHTML = template;

        $('#' + this.fieldApplyTo).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldApplyTo)
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: [{ Id: 'NEW', Name: this._getResource('ApplyTo_NEW') }, { Id: 'EDIT', Name: this._getResource('ApplyTo_EDIT') }, { Id: 'WHEN_NULL', Name: this._getResource('ApplyTo_WHEN_NULL') }]
        });

        $('#' + this.fieldDefValueToken).kendoComboBox({
            popup: {
                appendTo: $('#' + this.fieldDefValueToken)
            },
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            let dataType = 'STRING';

                            if (this.selectedField.EntityField) {
                                dataType = this.selectedField.EntityField.DataType;
                            } else if ($('#' + this.fieldDataType).data('kendoComboBox') != null) {
                                let cboxDataType = $('#' + this.fieldDataType).data('kendoComboBox').value();

                                if (cboxDataType != null && cboxDataType != '') {
                                    dataType = cboxDataType;
                                }
                            }

                            return rootURL + 'Entity/GetTokenType?dataType=' + dataType;
                        }
                    }
                }
            }
        });

        if (this.selectedField.DefValue.Token != null) {
            $('#' + this.fieldDefValueToken).data('kendoComboBox').value(this.selectedField.DefValue.Token);
        }

        if (this.selectedField.DefValue.Sql != null) {
            $('#' + this.fieldDefValueSql).val(this.selectedField.DefValue.Sql);
        }

        if (this.selectedField.DefValue.ApplyTo != null) {
            $('#' + this.fieldApplyTo).data('kendoComboBox').value(this.selectedField.DefValue.ApplyTo);
        }

        $('#' + this.fieldDefValueType + ' input').on('change', (evt) => {
            $('#' + this.fieldDefValueType + ' label').removeClass("btn-primary").addClass("btn-secondary");
            $(evt.currentTarget).closest("label").removeClass("btn-secondary").addClass("btn-primary");

            let currentValueType = $(evt.currentTarget).attr('data-option');

            if (currentValueType == 'VALUE') {
                $('#' + this.fieldDefValueValue + '-wrapper').show();
                $('#' + this.fieldDefValueToken + '-wrapper').hide();
                $('#' + this.fieldDefValueSql + '-wrapper').hide();
            } else if (currentValueType == 'TOKEN') {
                $('#' + this.fieldDefValueValue + '-wrapper').hide();
                $('#' + this.fieldDefValueToken + '-wrapper').show();
                $('#' + this.fieldDefValueSql + '-wrapper').hide();
            } else {
                $('#' + this.fieldDefValueValue + '-wrapper').hide();
                $('#' + this.fieldDefValueToken + '-wrapper').hide();
                $('#' + this.fieldDefValueSql + '-wrapper').show();
            }
        });

        $('#' + this.fieldDefValueType + ' input[data-option="' + this.selectedField.DefValue.ValueType + '"]').prop('checked', true);
        $('#' + this.fieldDefValueType + ' input[data-option="' + this.selectedField.DefValue.ValueType + '"]').change();

        this._initDefValueValue();
    }

    _getParagraphNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Label') + `</label>
                                                        <input type="text" id="` + this.fieldLabel + `" class="form-control" autocomplete="off"/>
                                                        <span id="Label-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getSublistNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;" help-key="EntityForm.Field.Sublist"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Label') + `</label>
                                                        <input type="text" id="` + this.fieldLabel + `" class="form-control" autocomplete="off"/>
                                                        <span id="Label-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label" help-key="EntityForm.Field.Sublist.IdList">` + this._getResource('IdList') + `</label>
                                                        <div class="col-sm-12 mb-3 d-flex p-0 m-0">
                                                            <div id="` + this.fieldIdList + `" class="form-control"></div>
                                                            <div class="input-group-append" style="display: grid;" id="` + this.fieldIdList + `-navigator">
                                                                <button title="` + this._getResource('NavigateRefList') + `" class="btn btn-primary btn-sm waves-effect waves-themed rounded-circle" type="button" onclick="formFieldsControl._openRefList('` + this.fieldIdList + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-external-link" style="font-size:1rem;"></i></button>
                                                            </div>
                                                        </div>
                                                        <span id="IdList-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="mb-3 col-6" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Autobind') + `</label>
                                                        <div id="` + this.fieldAutobind + `"></div>
                                                        <span id="IsAutobind-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label" help-key="EntityForm.Field.Sublist.SqlWhere">` + this._getResource('WhereClause') + `</label>
                                                        <textarea id="` + this.fieldWhereClause + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="SqlWhere-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label" help-key="EntityForm.Field.Sublist.IdEntityFieldForm">` + this._getResource('IdEntityFieldForm') + `</label>
                                                        <input type="text" id="` + this.fieldIdEntityFieldForm + `" class="form-control" autocomplete="off"/>
                                                        <span id="IdEntityFieldForm-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label" help-key="EntityForm.Field.Sublist.IdEntityFieldSublist">` + this._getResource('IdEntityFieldSublist') + `</label>
                                                        <input type="text" id="` + this.fieldIdEntityFieldSublist + `" class="form-control" autocomplete="off"/>
                                                        <span id="IdEntityFieldSublist-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                           <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                        <span id="Style-validation" class="field-error-message"></span>
                                                        <span id="HtmlAttributes-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getMapViewNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;" help-key="EntityForm.Field.MapView"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Label') + `</label>
                                                        <input type="text" id="` + this.fieldLabel + `" class="form-control" autocomplete="off"/>
                                                        <span id="Label-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <label class="form-label" help-key="EntityForm.Field.MapView.IdMap">` + this._getResource('IdMap') + `</label>
                                                        <div class="col-sm-12 mb-3 d-flex p-0 m-0">
                                                            <div id="` + this.fieldMapRef + `" class="form-control"></div>
                                                            <div class="input-group-append" style="display: grid;" id="` + this.fieldMapRef + `-navigator">
                                                                <button title="` + this._getResource('NavigateRefMap') + `" class="btn btn-primary btn-sm waves-effect waves-themed rounded-circle" type="button" onclick="formFieldsControl._openRefMap('` + this.fieldMapRef + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-external-link" style="font-size:1rem;"></i></button>
                                                            </div>
                                                        </div>
                                                        <span id="IdMap-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                        <span id="Style-validation" class="field-error-message"></span>
                                                        <span id="HtmlAttributes-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getGroupNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Text') + `</label>
                                                        <input type="text" id="` + this.fieldText + `" class="form-control" autocomplete="off"/>
                                                        <span id="Text-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-3 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Collapsable') + `</label>
                                                        <div id="` + this.fieldCollapsable + `"></div>
                                                        <span id="Collapsable-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label" style="margin-left: 5px;">` + this._getResource('Collapsed') + `</label>
                                                        <div id="` + this.fieldCollapsed + `"></div>
                                                        <span id="Collapsed-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getTabPageNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Text') + `</label>
                                                        <input type="text" id="` + this.fieldText + `" class="form-control" autocomplete="off"/>
                                                        <span id="Text-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getTabControlNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-behaviour-details')" style="cursor: pointer;"><a id="ui-item-behaviour-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-bolt mr-2"></i>` + this._getResource('BehaviourDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-behaviour-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('DependsOn') + `</label>
                                                        <div id="` + this.fieldDependsOn + `" class="form-control"></div>
                                                        <span id="DependsOnGuids-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('VisibilityCommand') + `</label>
                                                        <div id="` + this.fieldVisibilityCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandVisible-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ReadonlyCommand') + `</label>
                                                        <div id="` + this.fieldReadonlyCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandReadOnly-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ValidateCommand') + `</label>
                                                        <div id="` + this.fieldValidateCommand + `" class="form-control"></div>
                                                        <span id="IdXpCommandValid-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('LayoutCols') + `</label>
                                                        <input type="number" id="` + this.fieldLayoutCols + `" class="form-control" autocomplete="off"/>
                                                        <span id="LayoutCols-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <button id="` + this.fieldStyle + `" class="btn btn-primary" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                        <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    _getLayoutNodeTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow: auto;">
                            <div class="field-definition-content col-12">
                                <div class="panel-content p-0 col-xl-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-general-details')" style="cursor: pointer;"><a id="ui-item-general-details-anchor" class="nav-link active" data-toggle="tab" role="tab"><i class="fal fa-pencil-alt mr-2"></i>` + this._getResource('GeneralDetails') + `</a></li>
                                        <li class="nav-item" onclick="formFieldsControl._tabOnClick('ui-item-advanced-details')" style="cursor: pointer;"><a id="ui-item-advanced-details-anchor" class="nav-link" data-toggle="tab" role="tab"><i class="fal fa-cog mr-2"></i>` + this._getResource('AdvancedDetails') + `</a></li>
                                    </ul>
                                    <div class="tab-content p-0 pt-3">
                                        <div class="tab-pane fade show active col-sm-12 pl-0 pr-0" id="ui-item-general-details" role="tabpanel" style="display: block;">
                                            <div class="form-row col-sm-12 pl-0 pr-0">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Name') + `</label>
                                                        <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                                        <span id="Name-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row col-sm-12 pl-0 pr-0">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('Description') + `</label>
                                                        <textarea id="` + this.fieldDescription + `" class="form-control" autocomplete="off" style="min-height: 200px;"></textarea>
                                                        <span id="Description-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade col-sm-12 pl-0 pr-0" id="ui-item-advanced-details" role="tabpanel" style="display: block;">
                                            <div class="form-row col-sm-12 pl-0 pr-0">
                                                <div class="col-sm-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this._getResource('ClassName') + `</label>
                                                        <input type="text" id="` + this.fieldClassName + `" class="form-control" autocomplete="off"/>
                                                        <span id="ClassName-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row col-sm-12 pl-0 pr-0">
                                                <div class="form-group">
                                                    <button id="` + this.fieldStyle + `" class="btn btn-primary ml-2" title="` + this._getResource('Style') + `" type="button">` + this._getResource('Style') + `</button>
                                                    <button id="` + this.fieldHtmlAttributes + `" class="btn btn-primary ml-2" title="` + this._getResource('HtmlAttributes') + `" type="button">` + this._getResource('HtmlAttributes') + `</button>
                                                </div>
                                            </div>
                                            ` + (this.isFilter ? `
                                            <div class="form-row col-sm-12 pl-0 pr-0 pt-3">
                                                <div class="col-sm-12 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                                    <div class="form-group" style="display: flex; flex-direction: row-reverse;">
                                                        <label class="form-label pr-3" style="margin-left: 5px;">` + this._getResource('SameTab') + `</label>
                                                        <div id="` + this.fieldCollapsed + `"></div>
                                                        <span id="Collapsed-validation" class="field-error-message"></span>
                                                    </div>
                                                </div>
                                            </div>`: ``) + `
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }
}